/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s, i, o, n) {
  "use strict";

  function r(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = {
      NODE_ENV: "production",
    };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = {
      env: t,
    };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let a = u();

  function l() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = p('[data-section-type*="footer"]')),
      (t.headerHeight = p("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = p("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = p("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }

  function c() {
    document.addEventListener("theme:resize", d), h();
  }

  function h() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = l();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }

  function d() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = l(),
      n = u();
    (n !== a || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (a = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }

  function u() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }

  function p(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }

  function m(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }

  function v() {
    return (
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      window.innerWidth
    );
  }

  function g() {
    return (
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      window.innerHeight
    );
  }

  function f() {
    return v() >= window.theme.sizes.small;
  }

  function y() {
    return v() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let b = v(),
    w = g();
  let E = window.scrollY,
    S = null,
    L = null,
    k = null,
    A = null,
    C = 0;

  function T(e) {
    setTimeout(() => {
      C && clearTimeout(C),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }

  function q(t) {
    const e = t.detail;
    e ? (C = setTimeout(x, e)) : x();
  }

  function x() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const M = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };

  function P(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      M(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      M(t, "rte__video-wrapper");
    });
  }

  function I(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const H = "is-loading",
    O = "img.is-loading";

  function B(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }

  function D(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var F = {};

  function $(t, e) {
    e = e || {};
    var s = D(t),
      i = e.elementToFocus || t,
      o = s[0],
      n = s[s.length - 1];
    _(),
      (F.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          o &&
          o === e.target &&
          o.focus(),
          (e.target !== t && e.target !== n && e.target !== o) ||
            document.addEventListener("keydown", F.keydown);
      }),
      (F.focusout = function () {
        document.removeEventListener("keydown", F.keydown);
      }),
      (F.keydown = function (e) {
        "Tab" === e.code &&
          (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
          (e.target !== t && e.target !== o) ||
            !e.shiftKey ||
            (e.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", F.focusout),
      document.addEventListener("focusin", F.focusin),
      B(i, e);
  }

  function _() {
    document.removeEventListener("focusin", F.focusin),
      document.removeEventListener("focusout", F.focusout),
      document.removeEventListener("keydown", F.keydown);
  }

  function N() {
    window.accessibility.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        var t;
        null === (t = window.accessibility.lastElement) ||
          void 0 === t ||
          t.focus();
      });
  }
  var R = Object.freeze({
    __proto__: null,
    forceFocus: B,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && B(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                B(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: D,
    trapFocus: $,
    removeTrapFocus: _,
    autoFocusLastElement: N,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s,
          i,
          o,
          n = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          r = e.prefix || "a11y",
          a = {
            newWindow: r + "-new-window-message",
            external: r + "-external-message",
            newWindowExternal: r + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            o = "_blank" === e,
            n = null === s || -1 === s.indexOf("noopener");
          if (o && n) {
            var r = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", r);
          }
          i && o
            ? t.setAttribute("aria-describedby", a.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", a.external)
            : o && t.setAttribute("aria-describedby", a.newWindow);
        }),
          (s = n),
          (i = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
          }, "")),
          i.setAttribute("hidden", !0),
          (i.innerHTML = o),
          document.body.appendChild(i);
      }
    },
  });
  const W = 'input[type="search"]',
    z = '[aria-selected="true"] a',
    U = 'button[type="reset"]',
    V = "hidden";
  let j = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(V);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(V)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(V);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(z);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(W).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(W)),
        (this.resetButton = this.querySelector(U)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            m((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", j);
  const X = '[role="option"]',
    J = '[aria-selected="true"]',
    Y = "[data-popular-searches]",
    Q = "predictive-search",
    G = "[data-predictive-search-results]",
    K = "[data-predictive-search-status]",
    Z = 'input[type="search"]',
    tt = "[data-popdown]",
    et = "[data-predictive-search-live-region-count-value]",
    st = "[data-search-results-groups-wrapper]",
    it = "[data-predictive-search-search-for-text]",
    ot = "#shopify-section-predictive-search",
    nt = '[aria-selected="true"] a',
    rt = '[aria-selected="true"] a, button[aria-selected="true"]';
  let at = class extends j {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      var e;
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        null === (e = this.querySelector(st)) ||
        void 0 === e ||
        e.remove();
      this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(nt)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(nt);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(it),
        i = null == s ? void 0 : s.innerText;
      if (i) {
        var o;
        if (
          (null === (o = i.match(new RegExp(t, "g"))) || void 0 === o
            ? void 0
            : o.length) > 1
        )
          return;
        const n = i.replace(t, e);
        s.innerText = n;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(J),
        i = Array.from(this.querySelectorAll(X)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(rt);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              {
                signal: this.abortController.signal,
              }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(ot).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== (null == t ? void 0 : t.code))
                  throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(K)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(et).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0),
        this.predictiveSearchResults.style.setProperty(
          "--full-screen",
          `${window.visualViewport.height}px`
        );
    }
    close(t = !1) {
      this.closeResults(t),
        (this.isOpen = !1),
        this.predictiveSearchResults.style.removeProperty("--full-screen");
    }
    closeResults(t = !1) {
      var e;
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const s = this.querySelector(J);
      s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        null === (e = this.predictiveSearchResults) ||
          void 0 === e ||
          e.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(
            new Event("blur", {
              bubbles: !1,
            })
          ),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
    constructor() {
      var t;
      super(),
        (this.a11y = R),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(Q)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(Z)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(G)),
        (this.searchPopdown = this.closest(tt)),
        (this.popularSearches =
          null === (t = this.searchPopdown) || void 0 === t
            ? void 0
            : t.querySelector(Y)),
        (this.searchTerm = "");
    }
  };
  const lt = "[data-popout-list]",
    ct = "[data-popout-toggle]",
    ht = "[data-popout-toggle-text]",
    dt = "[data-popout-input]",
    ut = "[data-popout-option]",
    pt = "[data-product-image]",
    mt = "[data-grid-item]",
    vt = "popout-list--visible",
    gt = "is-visible",
    ft = "is-active",
    yt = "select-popout--top",
    bt = "aria-expanded",
    wt = "aria-current",
    Et = "data-value",
    St = "data-popout-toggle-text",
    Lt = "submit";
  let kt = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector(lt)),
          (this.popoutToggle = this.querySelector(ct)),
          (this.popoutToggleText = this.querySelector(ht)),
          (this.popoutInput = this.querySelector(dt)),
          (this.popoutOptions = this.querySelectorAll(ut)),
          (this.productGridItem = this.popoutList.closest(mt)),
          (this.fireSubmitEvent = this.hasAttribute(Lt)),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        const e = "true" === t.currentTarget.getAttribute(bt);
        if (this.productGridItem) {
          const t = this.productGridItem.querySelector(pt);
          t && t.classList.toggle(gt, !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGridItem.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(bt, !e),
          this.popoutList.classList.toggle(vt),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        const e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(vt) && !e && this._hideList();
      }
      toggleListPosition() {
        const t = "true" === this.querySelector(ct).getAttribute(bt),
          e = window.innerHeight,
          s = this.popoutList.getBoundingClientRect().bottom,
          i = () => {
            this.classList.remove(yt),
              this.popoutList.removeEventListener("transitionend", i);
          };
        t
          ? e < s && this.classList.add(yt)
          : this.popoutList.addEventListener("transitionend", i);
      }
      popupListMaxWidth() {
        this.popoutList.style.setProperty("--max-width", "100vw"),
          requestAnimationFrame(() => {
            this.popoutList.style.setProperty(
              "--max-width",
              `${parseInt(
                document.body.clientWidth -
                  this.popoutList.getBoundingClientRect().left
              )}px`
            );
          });
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(ut).attributes.href.value) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute(Et)
            ? t.currentTarget.getAttribute(Et)
            : "";
          if (
            ((this.popoutInput.value = e),
            this.popoutInput.disabled &&
              this.popoutInput.removeAttribute("disabled"),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            const s = t.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${ft}`),
              o = this.popoutList.querySelector(`[${wt}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i && (i.classList.remove(ft), s.classList.add(ft)),
              "quantity" != this.popoutInput.name ||
                s.nextSibling ||
                this.classList.add(ft),
              o &&
                o.hasAttribute(`${wt}`) &&
                (o.removeAttribute(`${wt}`),
                t.currentTarget.setAttribute(`${wt}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.innerHTML = e),
                this.popoutToggleText.hasAttribute(St) &&
                  "" !== this.popoutToggleText.getAttribute(St) &&
                  this.popoutToggleText.setAttribute(St, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        const e = this.contains(t.target);
        this.popoutList.classList.contains(vt) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        const t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(vt),
          this.popoutToggle.setAttribute(bt, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    At = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", {
            bubbles: !0,
          })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
          this.input.addEventListener("change", this.onQuantityChangeEvent),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value,
          s =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === s.name && this.input.stepUp(),
          "decrease" === s.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
      }
      onQuantityChange() {
        "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: {
                id: this.input.dataset.id,
                quantity: this.input.value,
              },
            })
          );
      }
      constructor() {
        super();
      }
    };
  const Ct = "[data-aos]:not(.aos-animate)",
    Tt = "[data-aos-anchor]",
    qt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    xt = "aos-animate",
    Mt = {
      attributes: !1,
      childList: !0,
      subtree: !0,
    };
  let Pt = [];
  const It = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(Ct),
            i = t.querySelectorAll(Tt);
          s.length &&
            s.forEach((t) => {
              Ht.observe(t);
            }),
            i.length && Bt(i);
        }
    },
    Ht = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(xt), e.unobserve(t.target));
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    ),
    Ot = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(Ct);
            s.length &&
              s.forEach((t) => {
                t.classList.add(xt);
              }),
              e.unobserve(t.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0.1, 0.25, 0.5, 0.75, 1],
      }
    );

  function Bt(t) {
    t.length &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === Pt.indexOf(e)) {
          const t = document.querySelector(e);
          t && (Ot.observe(t), Pt.push(e));
        }
      });
  }
  const Dt = "[data-deferred-media-button]",
    Ft = "video, model-viewer, iframe",
    $t = '[data-host="youtube"]',
    _t = '[data-host="vimeo"]',
    Nt = "[data-grid-item]",
    Rt = ".shopify-section",
    Wt = "template",
    zt = "video",
    Ut = "product-model",
    Vt = "loaded",
    jt = "autoplay";
  let Xt = class extends HTMLElement {
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(Vt) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(Vt)) {
        const t = this.querySelector($t),
          e = this.querySelector(_t),
          s = t || e,
          i = this.querySelector(zt);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Vt))) {
        const e = document.createElement("div"),
          s = this.querySelector(Wt).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(Vt, !0);
        const i = this.appendChild(e.querySelector(Ft));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(jt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll($t).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(_t).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(zt).forEach((t) => t.pause()),
        document.querySelectorAll(Ut).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector(Dt);
      null == t || t.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(Rt)),
        (this.productGridItem = this.closest(Nt)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
  };
  const Jt = "product-modal",
    Yt = "[data-popup-close]",
    Qt = "[data-notification-form]",
    Gt = "[data-product-notification-heading]",
    Kt = "has-success",
    Zt = "hidden";
  let te = class extends HTMLElement {
    connectedCallback() {
      this.checkState(),
        this.notificationForm.addEventListener("submit", (t) =>
          this.notificationSubmitEvent(t)
        ),
        this.popupClose.addEventListener("click", () => {
          this.removeStorage();
        });
    }
    checkState() {
      if (-1 !== window.location.search.indexOf("?contact_posted=true")) {
        this.querySelector(Gt).classList.add(Zt),
          this.closest(Jt).classList.add(Kt),
          this.popup.removeAttribute("inert"),
          "function" == typeof this.popup.showModal
            ? this.popup.showModal()
            : this.popup.setAttribute("open", "");
      }
    }
    notificationSubmitEvent(t) {
      this.preventSubmit &&
        (t.preventDefault(),
        this.removeStorage(),
        this.writeStorage(),
        (this.preventSubmit = !1),
        this.notificationForm.submit());
    }
    writeStorage() {
      void 0 !== window.sessionStorage &&
        window.sessionStorage.setItem(
          "notification_form_id",
          this.notificationForm.id
        );
    }
    removeStorage() {
      window.sessionStorage.removeItem("notification_form_id");
    }
    constructor() {
      super(),
        (this.notificationForm = this.querySelector(Qt)),
        (this.preventSubmit = !0),
        (this.popup = this.closest("dialog")),
        (this.popupClose = this.popup.querySelector(Yt));
    }
  };
  const ee = "is-visible";
  class se {
    init() {
      var t;
      const e = {
        root: this.container,
        threshold: [0.01, 0.5, 0.75, 0.99],
      };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(ee)
            : t.target.classList.remove(ee);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
  }
  const ie = "is-dragging",
    oe = "is-enabled",
    ne = "is-scrolling",
    re = "is-visible",
    ae = "[data-grid-item]";
  class le {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(ie, ne),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(ne);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(ie),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${ae}.${re}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(ne),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(oe),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(oe);
    }
  }
  const ce = "[data-button-arrow]",
    he = "[data-collection-image]",
    de = "[data-column-image]",
    ue = "[data-product-image]",
    pe = "[data-grid-item]",
    me = "[data-grid-slider]",
    ve = "data-button-prev",
    ge = "data-button-next",
    fe = "align-arrows",
    ye = "slider__arrows",
    be = "is-visible",
    we = "scroll-snap-disabled";
  class Ee extends HTMLElement {
    connectedCallback() {
      this.init(), this.addEventListener("theme:grid-slider:init", this.init);
    }
    init() {
      var t;
      (this.slider = this.querySelector(me)),
        (this.slides = this.querySelectorAll(pe)),
        (this.buttons = this.querySelectorAll(ce)),
        this.slider.classList.add(we),
        this.toggleSlider(),
        document.addEventListener("theme:resize:width", this.toggleSlider),
        ((t = this),
        new Promise((e) => {
          const s = t.querySelectorAll("[data-aos]");
          let i = 0;

          function o(t) {
            i++,
              i === s.length && e(),
              t.target.removeEventListener("animationend", o);
          }
          s.forEach((t) => {
            t.addEventListener("animationend", o);
          });
        })).then(() => {
          this.slider.classList.remove(we);
        });
    }
    toggleSlider() {
      if (
        !(this.slider.clientWidth < this.getSlidesWidth()) ||
        (!f() && window.theme.touch)
      )
        this.destroy();
      else {
        if (this.isInitialized) return;
        (this.slidesObserver = new se(this.slider, pe)),
          this.initArrows(),
          (this.isInitialized = !0),
          (this.draggableSlider = new le(this.slider));
      }
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(ye),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.append(t),
          (this.buttons = this.querySelectorAll(ce)),
          (this.buttonPrev = this.querySelector(`[${ve}]`)),
          (this.buttonNext = this.querySelector(`[${ge}]`));
      }
      this.toggleArrowsObserver(),
        this.hasAttribute(fe) &&
          (this.positionArrows(), this.arrowsResizeObserver()),
        this.buttons.forEach((t) => {
          t.addEventListener("click", this.onButtonArrowClick);
        });
    }
    buttonArrowClickEvent(t) {
      t.preventDefault();
      const e = this.slider.querySelector(`${pe}.${be}`);
      let s = null;
      t.target.hasAttribute(ve) &&
        (s = null == e ? void 0 : e.previousElementSibling),
        t.target.hasAttribute(ge) &&
          (s = null == e ? void 0 : e.nextElementSibling),
        this.goToSlide(s);
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${ye}`)) || void 0 === t || t.remove();
    }
    goToSlide(t) {
      t &&
        this.slider.scrollTo({
          top: 0,
          left: t.offsetLeft,
          behavior: "smooth",
        });
    }
    getSlidesWidth() {
      var t;
      return (
        (null === (t = this.slider.querySelector(pe)) || void 0 === t
          ? void 0
          : t.clientWidth) * this.slider.querySelectorAll(pe).length
      );
    }
    toggleArrowsObserver() {
      if (this.buttonPrev && this.buttonNext) {
        const t = this.slides.length,
          e = this.slides[0],
          s = this.slides[t - 1],
          i = {
            attributes: !0,
            childList: !1,
            subtree: !1,
          },
          o = (t) => {
            for (const i of t)
              if ("attributes" === i.type) {
                const t = i.target,
                  o = Boolean(t.classList.contains(be));
                t == e && (this.buttonPrev.disabled = o),
                  t == s && (this.buttonNext.disabled = o);
              }
          };
        e &&
          s &&
          ((this.firstLastSlidesObserver = new MutationObserver(o)),
          this.firstLastSlidesObserver.observe(e, i),
          this.firstLastSlidesObserver.observe(s, i));
      }
    }
    positionArrows() {
      const t =
        this.slider.querySelector(ue) ||
        this.slider.querySelector(he) ||
        this.slider.querySelector(de) ||
        this.slider;
      t &&
        this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
    }
    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }
    disconnectedCallback() {
      this.destroy(),
        document.removeEventListener("theme:resize:width", this.toggleSlider);
    }
    destroy() {
      var t, e;
      (this.isInitialized = !1),
        null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
        (this.draggableSlider = null),
        null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
        (this.slidesObserver = null),
        this.removeArrows(),
        document.removeEventListener("theme:resize:width", this.positionArrows);
    }
    constructor() {
      super(),
        (this.isInitialized = !1),
        (this.draggableSlider = null),
        (this.positionArrows = this.positionArrows.bind(this)),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.slidesObserver = null),
        (this.firstLastSlidesObserver = null),
        (this.isDragging = !1),
        (this.toggleSlider = this.toggleSlider.bind(this));
    }
  }
  const Se = "time",
    Le = "[data-days]",
    ke = "[data-hours]",
    Ae = "[data-minutes]",
    Ce = "[data-seconds]",
    Te = ".shopify-section",
    qe = "[data-countdown-block]",
    xe = "[data-ticker-text]",
    Me = "data-expiration-behavior",
    Pe = "data-clone",
    Ie = "show-message",
    He = "hidden",
    Oe = "hide-section",
    Be = "show-message";
  let De = class extends HTMLElement {
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.update(), (this.interval = setInterval(this.update, 1e3)));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= s * this.hoursInMs;
      const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= i * this.minutesInMs;
      return {
        days: e,
        hours: s,
        minutes: i,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      var t, e;
      (this.render({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      }),
      this.shouldHideOnComplete) &&
        (null === (t = this.countdownParent) ||
          void 0 === t ||
          t.classList.add(He),
        null === (e = this.countdownParent) ||
          void 0 === e ||
          e.dispatchEvent(
            new CustomEvent("theme:countdown:hide", {
              detail: {
                element: this,
              },
              bubbles: !0,
            })
          ));
      if (this.shouldShowMessage) {
        var s, i;
        if (
          (null === (s = this.classList) || void 0 === s || s.add(Ie),
          this.closest(xe).hasAttribute(Pe))
        )
          return;
        null === (i = this.countdownParent) ||
          void 0 === i ||
          i.dispatchEvent(
            new CustomEvent("theme:countdown:expire", {
              bubbles: !0,
            })
          );
      }
    }
    update() {
      const t = new Date().getTime(),
        e = this.endDate - t;
      e < 1e3 && (this.stopTimer(), this.onComplete());
      const s = this.convertTime(e);
      this.render(s);
    }
    constructor() {
      super(),
        (this.section = this.closest(Te)),
        (this.countdownParent = this.closest(qe) || this.section),
        (this.expirationBehavior = this.getAttribute(Me)),
        (this.time = this.querySelector(Se)),
        (this.days = this.querySelector(Le)),
        (this.hours = this.querySelector(ke)),
        (this.minutes = this.querySelector(Ae)),
        (this.seconds = this.querySelector(Ce)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === Oe),
        (this.shouldShowMessage = this.expirationBehavior === Be),
        (this.update = this.update.bind(this));
    }
  };
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(qt);
        t.length &&
          t.forEach((t) => {
            Ht.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(Tt);
        t.length && Bt(t);
      })(),
      new MutationObserver(It).observe(document.body, Mt),
      document.addEventListener("shopify:section:unload", (t) => {
        var e;
        const s =
            "#" +
            (null === (e = t.target.querySelector("[data-section-id]")) ||
            void 0 === e
              ? void 0
              : e.id),
          i = Pt.indexOf(s);
        -1 !== i && Pt.splice(i, 1);
      })),
    window.addEventListener(
      "resize",
      m(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", {
            bubbles: !0,
          })
        ),
          b !== v() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", {
                bubbles: !0,
              })
            ),
            (b = v())),
          w !== g() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", {
                bubbles: !0,
              })
            ),
            (w = g()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > E
                  ? ((L = !0), (S = !1))
                  : t < E
                  ? ((L = !1), (S = !0))
                  : ((S = null), (L = null)),
                  (E = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: {
                        up: S,
                        down: L,
                        position: t,
                      },
                      bubbles: !1,
                    })
                  ),
                  S &&
                    !k &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: {
                          position: t,
                        },
                        bubbles: !1,
                      })
                    ),
                  L &&
                    !A &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: {
                          position: t,
                        },
                        bubbles: !1,
                      })
                    ),
                  (A = L),
                  (k = S);
              })();
            }));
        },
        {
          passive: !0,
        }
      ),
        window.addEventListener("theme:scroll:lock", T),
        window.addEventListener("theme:scroll:unlock", q);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    h(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(H) &&
          (t.target.classList.remove(H),
          t.target.parentNode.classList.remove(H),
          t.target.parentNode.parentNode.classList.contains(H) &&
            t.target.parentNode.parentNode.classList.remove(H));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      c(),
        I(document),
        r(document),
        P(document),
        document.querySelectorAll(O).forEach((t) => {
          t.complete &&
            (t.classList.remove(H),
            t.parentNode.classList.remove(H),
            t.parentNode.parentNode.classList.contains(H) &&
              t.parentNode.parentNode.classList.remove(H));
        }),
        document.body.classList.add("is-loaded"),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      r(e), P(e), I(document), c();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", kt),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", At),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", at),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", Xt),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", Ee),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", De),
    customElements.get("product-notification") ||
      customElements.define("product-notification", te);
  const Fe = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      target: "api-product-grid-item",
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n, l, c) => {
        s.length && e < c
          ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
              .then((t) => t.text())
              .then((t) => {
                const i = 100 * e,
                  r = o.id ? `#${o.id}` : "",
                  h = document.createElement("div");
                let d = t;
                (d = d.includes("||itemAnimationDelay||")
                  ? d.replaceAll("||itemAnimationDelay||", i)
                  : d),
                  (d = d.includes("||itemAnimationAnchor||")
                    ? d.replaceAll("||itemAnimationAnchor||", r)
                    : d),
                  (h.innerHTML = d),
                  (o.innerHTML +=
                    h.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n, l, c);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n, l, c);
              })
          : ((e, s) => {
              Fe(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const $e = "is-focused",
    _e = "[data-skip-content]",
    Ne = 'a[href="#"]';
  window.accessibility = new (class {
    init() {
      (this.a11y = R),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(_e)),
        (this.linkesWithOnlyHash = document.querySelectorAll(Ne)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove($e);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add($e);
        });
    }
    constructor() {
      this.init();
    }
  })();

  function Re(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let s = "";
    const i = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "${{amount}}";

    function n(t, e = 2, s = ",", i = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) +
        (o[1] ? i + o[1] : "")
      );
    }
    switch (o.match(i)[1]) {
      case "amount":
        s = n(t, 2);
        break;
      case "amount_no_decimals":
        s = n(t, 0);
        break;
      case "amount_with_comma_separator":
        s = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        s = n(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        s = n(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        s = n(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        s = n(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        s = n(t, 2, " ", ".");
    }
    return o.replace(i, s);
  }
  const We = (t, e) => {
    let s, i;
    return function o(...n) {
      const r = Date.now();
      (i = clearTimeout(i)),
        !s || r - s >= e
          ? (t.apply(null, n), (s = r))
          : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
    };
  };

  function ze(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  ze.prototype = Error.prototype;
  const Ue = "is-animated",
    Ve = "is-added",
    je = "is-disabled",
    Xe = "is-empty",
    Je = "is-hidden",
    Ye = "is-hiding",
    Qe = "is-loading",
    Ge = "is-open",
    Ke = "is-removed",
    Ze = "is-success",
    ts = "is-visible",
    es = "is-expanded",
    ss = "is-updated",
    is = "variant--soldout",
    os = "variant--unavailable",
    ns = "[data-api-content]",
    rs = "[data-api-line-items]",
    as = "[data-api-upsell-items]",
    ls = "[data-api-cart-price]",
    cs = "[data-animation]",
    hs = "[data-skip-upsell-product]",
    ds = "[data-add-to-cart-bar]",
    us = "[data-cart-error-close]",
    ps = "cart-drawer",
    ms = "[data-cart-drawer-close]",
    vs = "[data-cart-empty]",
    gs = "[data-cart-errors]",
    fs = "[data-item-remove]",
    ys = "[data-cart-page]",
    bs = "[data-cart-form]",
    ws = "[data-cart-acceptance-checkbox]",
    Es = "[data-cart-checkout-buttons]",
    Ss = "[data-cart-checkout-button]",
    Ls = "[data-cart-total]",
    ks = "[data-checkout-buttons]",
    As = "[data-error-message]",
    Cs = "[data-close-error]",
    Ts = "[data-cart-errors-container]",
    qs = "[data-form-wrapper]",
    xs = "[data-free-shipping]",
    Ms = "[data-progress-graph]",
    Ps = "[data-progress-bar]",
    Is = "[data-header-wrapper]",
    Hs = "[data-item]",
    Os = "[data-items-holder]",
    Bs = "[data-left-to-spend]",
    Ds = "[data-drawer]",
    Fs = "[data-section-id]",
    $s = "[data-cart-price-holder]",
    _s = "[data-quick-add-holder]",
    Ns = "[data-quick-add-modal]",
    Rs = 'input[name="updates[]"]',
    Ws = "[data-upsell-products]",
    zs = "[data-upsell-widget]",
    Us = "[data-terms-error-message]",
    Vs = "[data-collapsible-body]",
    js = "recently-viewed-products-cart",
    Xs = "data-cart-total",
    Js = "disabled",
    Ys = "data-free-shipping",
    Qs = "data-free-shipping-limit",
    Gs = "data-item",
    Ks = "data-item-index",
    Zs = "data-item-title",
    ti = "open",
    ei = "data-quick-add-holder",
    si = "data-scroll-locked",
    ii = "data-upsell-auto-open";
  let oi = class extends HTMLElement {
    connectedCallback() {
      (this.cartPage = document.querySelector(ys)),
        (this.cartForm = document.querySelector(bs)),
        (this.cartDrawer = document.querySelector(ps)),
        (this.cartEmpty = document.querySelector(vs)),
        (this.cartTermsCheckbox = document.querySelector(ws)),
        (this.cartCheckoutButtonWrapper = document.querySelector(Es)),
        (this.cartCheckoutButton = document.querySelector(Ss)),
        (this.checkoutButtons = document.querySelector(ks)),
        (this.itemsHolder = document.querySelector(Os)),
        (this.priceHolder = document.querySelector($s)),
        (this.items = document.querySelectorAll(Hs)),
        (this.cartTotal = document.querySelector(Ls)),
        (this.freeShipping = document.querySelectorAll(xs)),
        (this.cartErrorHolder = document.querySelector(gs)),
        (this.cartCloseErrorMessage = document.querySelector(us)),
        (this.headerWrapper = document.querySelector(Is)),
        (this.navDrawer = document.querySelector(Ds)),
        (this.upsellProductsHolder = document.querySelector(Ws)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener("theme:cart-drawer:open", this.animateItems),
        document.addEventListener(
          "theme:cart-drawer:close",
          this.onCartDrawerClose
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(Qs)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.formSubmitHandler = We(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.animateItems(),
          this.recentlyViewedProducts(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.dispatchEvent(
            new CustomEvent("theme:cart:load", {
              bubbles: !0,
            })
          ));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:unload", {
            bubbles: !0,
          })
        ),
        document.documentElement.hasAttribute(si) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          );
    }
    onCartDrawerClose() {
      var t;
      this.resetAnimatedItems(),
        (null === (t = this.cartDrawer) || void 0 === t
          ? void 0
          : t.classList.contains(Ge)) && this.cart.classList.remove(ss),
        this.cartEmpty.classList.remove(ss),
        this.cartErrorHolder.classList.remove(es),
        this.cart.querySelectorAll(cs).forEach((t) => {
          const e = () => {
            t.classList.remove(Ye), t.removeEventListener("animationend", e);
          };
          t.classList.add(Ye), t.addEventListener("animationend", e);
        });
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(Hs)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              {
                id: e.detail.id,
                quantity: e.detail.quantity,
              },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(fs).forEach((t) => {
        const e = t.closest(Hs);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(je) ||
              this.updateCart(
                {
                  id: t.dataset.id,
                  quantity: 0,
                },
                e
              );
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(es);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      i.checkValidity()
        ? ((e = new FormData(i)),
          (null !== i && i.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, s)))
        : i.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(ws).checked,
        e = document.querySelector(Us);
      if (t)
        e.classList.remove(es), this.cartCheckoutButton.removeAttribute(Js);
      else {
        if (document.querySelector(Us).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(Js, !0),
          e.classList.add(es);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(Cs);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(ts);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(ns);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(Qe);
      const s = null == e ? void 0 : e.closest(_s);
      e && (e.classList.add(Qe), (e.disabled = !0)),
        s && s.classList.add(ts),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(Qe), (e.disabled = !1)))
              );
            this.cart
              ? (e &&
                  (e.classList.remove(Qe),
                  e.classList.add(Ve),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: {
                        response: t,
                        button: e,
                      },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(Qe);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(Qe) : e.classList.add(Ke)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${Gs}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(Ks))
          ? parseInt(i.getAttribute(Ks))
          : 0,
        n = (null == i ? void 0 : i.hasAttribute(Zs))
          ? i.getAttribute(Zs)
          : null;
      if (0 === o) return;
      const r = {
        line: o,
        quantity: s,
      };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(Rs),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(Qe);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${fs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(je), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(Js, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${fs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(je), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(Js);
          }),
        this.cart.classList.remove(Qe);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(As).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(es, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ze({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    addToCartError(t, e) {
      var s;
      if (null !== e) {
        const s = e.closest(Fs) || e.closest(_s) || e.closest(Ns);
        let i = null == s ? void 0 : s.querySelector(Ts);
        const o = e.closest(_s);
        if ((o && o.querySelector(Ts) && (i = o.querySelector(Ts)), i)) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(ts),
            this.formErrorsEvents(i);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: {
              response: t,
              button: e,
            },
            bubbles: !0,
          })
        );
      }
      const i = null == e ? void 0 : e.closest(_s);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: i,
            },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(Qe);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(ds);
      e.push(o),
        (s = o.closest(_s)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(Qe), i || t.classList.add(Ve);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(Ve);
            (null === (e = t.closest(qs)) || void 0 === e
              ? void 0
              : e.classList.contains(is)) ||
              (null === (s = t.closest(qs)) || void 0 === s
                ? void 0
                : s.classList.contains(os)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(ts);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle(Xe, !t),
        t ||
          setTimeout(() => {
            $(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(ms),
            });
          }, 100);
    }
    build(t) {
      var e;
      const s = t.querySelector(rs),
        i = t.querySelector(as),
        o = Boolean(null === s && null === i),
        n = t.querySelector(ls),
        r = t.querySelector(Ls);
      this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
        o
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = s.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          s && s.querySelectorAll(Hs).length
            ? s.querySelectorAll(Hs).length
            : 0),
        (this.subtotal =
          r && r.hasAttribute(Xs) ? parseInt(r.getAttribute(Xs)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: {
              cartCount: this.cartCount,
            },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : Re(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        (null === (e = this.cartDrawer) || void 0 === e
          ? void 0
          : e.classList.contains(Ge)) && this.cart.classList.add(ss),
        this.cart.classList.remove(Qe),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(cs).forEach((t) => {
            t.classList.remove(Ue);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", {
            bubbles: !0,
          })
        );
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(Rs)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute(Ys) && "true" === e.getAttribute(Ys) && t >= 0;
          e.classList.toggle(Ze, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(xs)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        s = this.circumference - ((e / 100) * this.circumference) / 2,
        i = Re(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
      this.freeShipping.forEach((t) => {
        const o = t.querySelector(Ps),
          n = t.querySelector(Ms),
          r = t.querySelector(Bs);
        r && (r.innerHTML = i.replace(".00", "")),
          o && (o.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${s}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(hs);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(_s).getAttribute(ei);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${ei}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(_s),
        e = this.upsellProductsHolder.closest(zs);
      if (
        e &&
        (e.classList.toggle(Je, !t.length),
        t.length && !e.hasAttribute(ti) && e.hasAttribute(ii))
      ) {
        e.setAttribute(ti, !0);
        const t = e.querySelector(Vs);
        t && (t.style.height = "auto");
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(cs).forEach((t) => {
        t.classList.remove(Ue), t.classList.remove(Ye);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          null == e ||
            e.querySelectorAll(cs).forEach((t) => {
              t.classList.add(Ue);
            });
      });
    }
    recentlyViewedProducts() {
      this.cart.querySelector(`#${js}`) &&
        Shopify.Products.showRecentlyViewed({
          howManyToShow: 3,
          wrapperId: js,
          section: this,
          target: "api-upsell-product",
        });
    }
    constructor() {
      super();
    }
  };
  customElements.get("cart-items") || customElements.define("cart-items", oi);
  const ni = "data-cart-count",
    ri = "data-limit";
  let ai = class extends HTMLElement {
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(ni, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(ri)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
  };

  function li(t) {
    return new Promise((e) => {
      null == t ||
        t.addEventListener("animationend", function s(i) {
          i.target == t && (t.removeEventListener("animationend", s), e());
        });
    });
  }
  customElements.get("cart-count") || customElements.define("cart-count", ai);
  const ci = "is-open",
    hi = "is-closing",
    di = "drawer--duplicate",
    ui = "drawer-editor-error",
    pi = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    mi = "data-drawer-underlay";
  let vi = class extends HTMLElement {
    connectedCallback() {
      const t = this.closest(pi.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(ui),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${ui}`) ||
              this.querySelector(pi.cartDrawerInner).append(t),
            this.classList.add(di);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(pi.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(pi.shopifySection) ||
        t.target.closest(pi.shopifySection) ||
        t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(di)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: {
              target: this,
            },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
          })
        ),
        this.classList.add(ci),
        this.observeAdditionalCheckoutButtons(),
        li(this.cartDrawerInner).then(() => {
          $(this, {
            elementToFocus: this.querySelector(pi.cartDrawerClose),
          });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(ci) &&
        (this.classList.add(hi),
        this.classList.remove(ci),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", {
            bubbles: !0,
          })
        ),
        _(),
        N(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", {
            bubbles: !0,
          })
        ),
        li(this.cartDrawerInner).then(() => {
          this.classList.remove(hi);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(mi) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(pi.additionalCheckoutButtons);
      if (t) {
        const e = new MutationObserver(() => {
          $(this, {
            elementToFocus: this.querySelector(pi.cartDrawerClose),
          }),
            e.disconnect();
        });
        e.observe(t, {
          subtree: !0,
          childList: !0,
        });
      }
    }
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(pi.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(pi.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(pi.shopifySection)),
        this.closeCartEvents();
    }
  };
  customElements.get("cart-drawer") || customElements.define("cart-drawer", vi);
  const gi = "[data-collapsible]",
    fi = "[data-collapsible-trigger]",
    yi = "[data-collapsible-body]",
    bi = "[data-collapsible-content]",
    wi = "desktop",
    Ei = "disabled",
    Si = "mobile",
    Li = "open",
    ki = "single";
  let Ai = class extends HTMLElement {
    connectedCallback() {
      this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          const e = t.querySelector(fi),
            s = t.querySelector(yi);
          null == e ||
            e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
            s.addEventListener("transitionend", (e) => {
              e.target === s &&
                ("true" == t.getAttribute(Li) && this.setBodyHeight(s, "auto"),
                "false" == t.getAttribute(Li) &&
                  (t.removeAttribute(Li), this.setBodyHeight(s, "")));
            });
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle);
    }
    toggle() {
      const t = f();
      this.collapsibles.forEach((e) => {
        const s = e.hasAttribute(wi) ? e.getAttribute(wi) : "true",
          i = e.hasAttribute(Si) ? e.getAttribute(Si) : "true",
          o = e.querySelector(yi);
        (t && "true" == s) || (!t && "true" == i)
          ? (e.querySelector(fi).removeAttribute("tabindex"),
            e.removeAttribute(Li),
            e.removeAttribute(Ei),
            this.setBodyHeight(o, ""))
          : (e.setAttribute(Ei, ""),
            e.setAttribute("open", !0),
            e.querySelector(fi).setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(yi),
        s = t.querySelector(bi);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(yi),
        s = t.querySelector(bi);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = t.target.closest(gi);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(Li) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(Li) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: {
              element: "accordion",
            },
          })
        );
    }
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(gi)),
        (this.single = this.hasAttribute(ki)),
        (this.toggle = this.toggle.bind(this));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", Ai);
  const Ci = "details",
    Ti = "[data-popdown]",
    qi = "[data-popdown-close]",
    xi = 'input:not([type="hidden"])',
    Mi = "data-popdown-underlay",
    Pi = "is-open";
  let Ii = class extends HTMLElement {
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(Pi)
          ? "transform" === t.propertyName &&
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(xi),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(Mi)) || this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
          })
        ),
        requestAnimationFrame(() => {
          this.classList.add(Pi);
        });
    }
    close() {
      this.classList.remove(Pi),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", {
            bubbles: !0,
          })
        );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(Ti)),
        (this.popdownContainer = this.querySelector(Ci)),
        (this.popdownClose = this.querySelector(qi)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.a11y = R);
    }
  };
  customElements.define("header-search-popdown", Ii);
  const Hi = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends j {
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        f() ||
          this.scrollIntoView({
            behavior: "smooth",
          });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(Hi)),
          this.setupEventListeners();
      }
    }
  );
  const Oi = (t, e = [], s = !1) => {
      const i = Object.keys(t)
        .map((i) => {
          let o = t[i];
          if (
            "[object Object]" === Object.prototype.toString.call(o) ||
            Array.isArray(o)
          )
            return (
              Array.isArray(t) ? e.push("") : e.push(i),
              Oi(o, e, Array.isArray(o))
            );
          {
            let t = i;
            if (e.length > 0) {
              t = (s ? e : [...e, i]).reduce(
                (t, e) => ("" === t ? e : `${t}[${e}]`),
                ""
              );
            }
            return s ? `${t}[]=${o}` : `${t}=${o}`;
          }
        })
        .join("&");
      return e.pop(), i;
    },
    Bi = "[data-template-no-shipping]",
    Di = ".get-rates",
    Fi = "#address_container",
    $i = "#address_country",
    _i = "#address_province",
    Ni = "#address_zip",
    Ri = "#wrapper-response",
    Wi = "#shipping-calculator-response-template",
    zi = "data-template-no-shipping",
    Ui = "data-default",
    Vi = "is-hidden",
    ji = "error",
    Xi = "center",
    Ji = "success",
    Yi = "disabled",
    Qi = "get-rates--trigger",
    Gi = "Error : country is not supported.",
    Ki = "We do not ship to this destination.",
    Zi = "Error : ";
  let to = class extends HTMLElement {
    connectedCallback() {
      const t = document.querySelector("html");
      let s = "en";
      if (
        (t.hasAttribute("lang") &&
          "" !== t.getAttribute("lang") &&
          (s = t.getAttribute("lang")),
        this.fieldsContainer &&
          e.AddressForm(this.fieldsContainer, s, {
            shippingCountriesOnly: !0,
          }),
        this.selectCountry &&
          this.selectCountry.hasAttribute(Ui) &&
          this.selectProvince &&
          this.selectProvince.hasAttribute(Ui) &&
          this.selectCountry.addEventListener(
            "change",
            this.onCountryChangeEvent
          ),
        this.getRatesButton &&
          (this.getRatesButton.addEventListener(
            "click",
            this.onButtonClickEvent
          ),
          theme.settings.customerLoggedIn &&
            this.getRatesButton.classList.contains(Qi)))
      ) {
        const t = document.querySelector(Ni);
        t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
      }
    }
    disconnectedCallback() {
      this.selectCountry &&
        this.selectCountry.hasAttribute(Ui) &&
        this.selectProvince &&
        this.selectProvince.hasAttribute(Ui) &&
        this.selectCountry.removeEventListener(
          "change",
          this.onCountryChangeEvent
        ),
        this.getRatesButton &&
          this.getRatesButton.removeEventListener(
            "click",
            this.onButtonClickEvent
          );
    }
    onCountryChange() {
      this.selectCountry.removeAttribute(Ui),
        this.selectProvince.removeAttribute(Ui);
    }
    onButtonClick() {
      for (this.disableButtons(); this.wrapper.firstChild; )
        this.wrapper.removeChild(this.wrapper.firstChild);
      this.wrapper.classList.add(Vi);
      const t = {};
      let e = this.selectCountry.value,
        s = this.selectProvince.value;
      const i = this.selectCountry.getAttribute(Ui);
      "" === e && i && "" !== i && (e = i);
      const o = this.selectProvince.getAttribute(Ui);
      "" === s && o && "" !== o && (s = o),
        (t.zip = document.querySelector(Ni).value || ""),
        (t.country = e || ""),
        (t.province = s || ""),
        this.getCartShippingRatesForDestination(t);
    }
    formatRate(t) {
      return "0.00" === t
        ? window.theme.strings.free
        : Re(t, theme.moneyFormat);
    }
    render(t) {
      if (this.template && this.wrapper) {
        this.wrapper.innerHTML = "";
        let e = "",
          s = "",
          i = `${ji} ${Xi}`,
          o = this.template.innerHTML;
        const n = /[^[\]]+(?=])/g;
        if (t.rates && t.rates.length) {
          let s = n.exec(o)[0];
          t.rates.forEach((t) => {
            let i = s;
            (i = i.replace(/\|\|rateName\|\|/, t.name)),
              (i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))),
              (e += i);
          });
        }
        if (t.success) {
          i = `${Ji} ${Xi}`;
          const e = document.createElement("div");
          e.innerHTML = this.template.innerHTML;
          const o = e.querySelector(Bi);
          t.rates.length < 1 && o && (s = o.getAttribute(zi));
        } else s = t.errorFeedback;
        (o = o.replace(n, "").replace("[]", "")),
          (o = o.replace(/\|\|ratesList\|\|/g, e)),
          (o = o.replace(/\|\|successClass\|\|/g, i)),
          (o = o.replace(/\|\|ratesText\|\|/g, s)),
          (this.wrapper.innerHTML += o),
          this.wrapper.classList.remove(Vi);
      }
    }
    enableButtons() {
      this.getRatesButton.removeAttribute("disabled"),
        this.getRatesButton.classList.remove(Yi),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButton);
    }
    disableButtons() {
      this.getRatesButton.setAttribute("disabled", "disabled"),
        this.getRatesButton.classList.add(Yi),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButtonDisabled);
    }
    getCartShippingRatesForDestination(t) {
      const e = encodeURI(
          Oi({
            shipping_address: t,
          })
        ),
        s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
      fetch(s)
        .then(this.handleErrors)
        .then((t) => t.text())
        .then((e) => {
          const s = JSON.parse(e).shipping_rates;
          this.onCartShippingRatesUpdate(s, t);
        })
        .catch((t) => {
          this.onError(t.json);
        });
    }
    fullMessagesFromErrors(t) {
      const e = [];
      for (const s in t) for (const i of t[s]) e.push(i);
      return e;
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ze({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    onError(t) {
      this.enableButtons();
      let e = "";
      (e = t.message
        ? t.message + "(" + t.status + "): " + t.description
        : Zi + this.fullMessagesFromErrors(t).join("; ")),
        e === Gi && (e = Ki),
        this.render({
          rates: [],
          errorFeedback: e,
          success: !1,
        });
    }
    onCartShippingRatesUpdate(t, e) {
      this.enableButtons();
      let s = "";
      e.zip && (s += e.zip + ", "),
        e.province && (s += e.province + ", "),
        (s += e.country),
        this.render({
          rates: t,
          address: s,
          success: !0,
        });
    }
    constructor() {
      super(),
        (this.getRatesButton = this.querySelector(Di)),
        (this.fieldsContainer = this.querySelector(Fi)),
        (this.selectCountry = this.querySelector($i)),
        (this.selectProvince = this.querySelector(_i)),
        (this.template = this.querySelector(Wi)),
        (this.wrapper = this.querySelector(Ri)),
        (this.onCountryChangeEvent = () => this.onCountryChange()),
        (this.onButtonClickEvent = () => this.onButtonClick());
    }
  };
  customElements.get("shipping-calculator") ||
    customElements.define("shipping-calculator", to);
  const eo = "[data-actions]",
    so = "[data-content]",
    io = "[data-button]",
    oo = "data-height",
    no = "is-open",
    ro = "is-enabled";
  let ao = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(no);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        ro,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(oo)),
        (this.content = this.querySelector(so)),
        (this.trigger = this.querySelector(io)),
        (this.actions = this.querySelector(eo)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", ao);
  const lo = ".template-addresses",
    co = "#AddressNewForm",
    ho = ".address-new-toggle",
    uo = ".address-edit-toggle",
    po = ".address-delete",
    mo = "data-form-id",
    vo = "data-confirm-message",
    go = "#EditAddress",
    fo = "AddressCountryNew",
    yo = "AddressProvinceNew",
    bo = "AddressProvinceContainerNew",
    wo = ".address-country-option",
    Eo = "AddressCountry",
    So = "AddressProvince",
    Lo = "AddressProvinceContainer",
    ko = "hidden";
  const Ao = document.querySelector(lo);
  Ao &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const s = t.querySelectorAll(ho);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(ko);
              });
            });
          const i = t.querySelectorAll(uo);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(mo);
                t.querySelector(`${go}_${e}`).classList.toggle(ko);
              });
            });
          const o = t.querySelectorAll(po);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(mo),
                  e = this.getAttribute(vo);
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    {
                      parameters: {
                        _method: "delete",
                      },
                    }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(fo, yo, {
            hideElement: bo,
          }),
          this.section.querySelectorAll(wo).forEach((t) => {
            const e = t.getAttribute(mo),
              s = `${Eo}_${e}`,
              i = `${So}_${e}`,
              o = `${Lo}_${e}`;
            new Shopify.CountryProvinceSelector(s, i, {
              hideElement: o,
            });
          });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(co)),
          this.init();
      }
    })(Ao);
  const Co = ".customer-logged-in",
    To = ".account",
    qo = ".account-sidebar--mobile";
  const xo = document.querySelector(Co);
  xo &&
    new (class {
      init() {
        this.section.querySelector(To) && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(qo) &&
          this.section.querySelector(qo).addEventListener("click", function () {
            const t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(xo);
  const Mo = "[data-account-form]",
    Po = "[data-show-reset]",
    Io = "[data-hide-reset]",
    Ho = "[data-recover-password]",
    Oo = "[data-recover-success]",
    Bo = "[data-login-form]",
    Do = "#recover",
    Fo = "is-hidden";
  const $o = document.querySelector(Mo);
  $o &&
    new (class {
      init() {
        window.location.hash == Do || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(Fo),
          this.recover.classList.remove(Fo),
          (window.location.hash = Do),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(Fo),
          this.login.classList.remove(Fo),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(Po)),
          (this.hideButton = t.querySelector(Io)),
          (this.recover = t.querySelector(Ho)),
          (this.recoverSuccess = t.querySelector(Oo)),
          (this.login = t.querySelector(Bo)),
          this.init();
      }
    })($o),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const _o = window.Shopify.theme.sections.registered,
    No = window.Shopify.theme.sections.instances,
    Ro = "data-section-id",
    Wo = "data-section-type";
  let zo = class {
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = {
          id: this.id,
          type: this.type,
          container: this.container,
        };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(Ro))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              Ro +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(Ro)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
  };

  function Uo(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== _o[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, s] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof s
                ? t.push(s)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    })(t, e);
    return (_o[t] = s), _o;
  }

  function Vo(t, e) {
    (t = Jo(t)),
      void 0 === e && (e = document.querySelectorAll("[" + Wo + "]")),
      (e = Yo(e)),
      t.forEach(function (t) {
        const s = _o[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(jo(e).length > 0) &&
              null !== e.getAttribute(Wo) &&
              (e.getAttribute(Wo) !== t || (No.push(new zo(e, s)), !1))
            );
          }));
      });
  }

  function jo(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      Yo(t).forEach(function (t) {
        e = e.concat(
          No.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      Jo(t).forEach(function (t) {
        e = e.concat(
          No.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }

  function Xo(t) {
    for (var e, s = 0; s < No.length; s++)
      if (No[s].id === t) {
        e = No[s];
        break;
      }
    return e;
  }

  function Jo(t) {
    return (
      "*" === t
        ? (t = Object.keys(_o))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === zo
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === zo &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }

  function Yo(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ro + '="' + e + '"]');
      null !== s && Vo(s.getAttribute(Wo), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ro + '="' + e + '"]');
      "object" == typeof jo(s)[0] &&
        jo(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ro + '="' + e + '"]');
      "object" == typeof jo(s)[0] &&
        jo(s).forEach(function (t) {
          var e = No.map(function (t) {
            return t.id;
          }).indexOf(t.id);
          No.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = Xo(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = Xo(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = Xo(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = Xo(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Qo = "data-tooltip",
    Go = "data-tooltip-stop-mouseenter",
    Ko = "tooltip-default",
    Zo = "is-visible",
    tn = "is-hiding";
  let en = {},
    sn = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        const e = document.querySelector(`.${this.class}`);
        if (this.label && e && ((t && !this.tooltip.hasAttribute(Go)) || !t)) {
          const t = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).innerHTML = this.label;
          const i = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            n = o.top,
            r = o.width,
            a = n + o.height + window.scrollY;
          let l = o.left - i / 2 + r / 2;
          const c = 24,
            h = l + i - v() + c;
          h > 0 && (l -= h),
            l < 0 && (l = 0),
            (t.style.left = `${o.left + r / 2}px`),
            e.style.setProperty("--tooltip-top", `${a}px`),
            (s.style.transform = `translateX(${l}px)`),
            e.classList.remove(tn),
            e.classList.add(Zo),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(Zo);
        i &&
          ((e && !this.tooltip.hasAttribute(Go)) || !e) &&
          (o &&
            (s || t.detail.hideTransition) &&
            (i.classList.add(tn),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(tn);
            }, this.transitionSpeed))),
          i.classList.remove(Zo),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(Qo) &&
            ((this.label = this.tooltip.getAttribute(Qo)),
            (this.class = e.class || Ko),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => We(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    };
  const on = {
    onLoad() {
      en[this.id] = [];
      this.container.querySelectorAll(`[${Qo}]`).forEach((t) => {
        en[this.id].push(new sn(t));
      });
    },
    onUnload: function () {
      en[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var nn = {};
  const rn = {
    onLoad() {
      nn[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const e = t.querySelector("[data-parallax-img]");
          nn[this.id].push(
            new s(e, {
              center: !0,
              round: !0,
              frame: t,
            })
          );
        }),
        window.addEventListener("load", () => {
          nn[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      nn[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  Uo("article", [on, rn]);
  const an = "[data-aos]",
    ln = ".collection-item__image",
    cn = "[data-column-image]",
    hn = ".flickity-button.next",
    dn = ".flickity-button.previous",
    un = "a:not(.btn)",
    pn = ".product-item__image",
    mn = "[data-slide]",
    vn = "data-slide",
    gn = "[data-slider]",
    fn = "[data-slider-thumb]",
    yn = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    bn = "aos-animate",
    wn = "desktop",
    En = "is-focused",
    Sn = "flickity-enabled",
    Ln = "is-initialized",
    kn = "is-loading",
    An = "is-selected",
    Cn = "mobile",
    Tn = "single-slide",
    qn = "js-slider--initialized",
    xn = {};
  let Mn = class {
    init() {
      this.slideshow.classList.add(kn);
      let t = mn;
      const e = f(),
        s = `${mn}:not(.${Cn})`,
        n = `${mn}:not(.${wn})`;
      (this.slideshow.querySelectorAll(n).length ||
        this.slideshow.querySelectorAll(s).length) &&
        (t = e ? s : n),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(Tn),
          this.slideshow.classList.remove(kn)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(Ln),
                  this.slideshow.classList.remove(kn),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: {
                        slider: this,
                      },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(an);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(bn),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(bn);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new o(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new i(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(kn);
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${An}`);
      if (!e) return;
      const s = e.hasAttribute(yn.slideTextColor)
          ? e.getAttribute(yn.slideTextColor)
          : "",
        i = e.querySelector(un),
        o = this.slideshow.querySelectorAll(`${mn} a, ${mn} button`);
      if (
        (document.body.classList.contains(En) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(mn);
            if (e) {
              const s = e.classList.contains(An) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(yn.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(yn.slideIndex)),
          s = this.container.querySelector(`${fn}.${An}`);
        s && s.classList.remove(An), this.sliderThumbs[t].classList.add(An);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(yn.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(ln) ||
          this.slideshow.querySelector(pn) ||
          this.slideshow.querySelector(cn);
        if (!t) return;
        (this.slideshow.querySelector(dn).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(hn).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${vn}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(yn.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(qn) && (s = 0),
        this.slideshow.classList.add(An),
        this.flkty &&
          this.slideshow.classList.contains(Sn) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(An),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(gn)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(mn)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(fn)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              yn.slidesLargeDesktop
            )),
            this.slideshow.hasAttribute(yn.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(yn.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const Pn = {
    onLoad() {
      xn[this.id] = [];
      this.container.querySelectorAll(gn).forEach((t) => {
        xn[this.id].push(new Mn(this.container, t));
      });
    },
    onUnload() {
      xn[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      xn[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      xn[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  Uo("blog-section", [Pn]), Uo("hero", rn), Uo("double", Pn);
  const In = (t) => {
    let { stickyHeaderHeight: e } = l();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  let Hn = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
  };
  const On = "[data-newsletter-form]",
    Bn = "[data-newsletter-heading]",
    Dn = "[data-newsletter]",
    Fn = "has-success",
    $n = "has-error",
    _n = "hidden",
    Nn = "data-cookie-name",
    Rn = {};
  const Wn = {
    onLoad() {
      Rn[this.id] = [];
      this.container.querySelectorAll(On).forEach((t) => {
        Rn[this.id].push(
          new (class {
            init() {
              this.newsletter.addEventListener("submit", this.newsletterSubmit),
                this.showMessage();
            }
            newsletterSubmitEvent(t) {
              this.stopSubmit &&
                (t.preventDefault(),
                t.stopImmediatePropagation(),
                this.removeStorage(),
                this.writeStorage(),
                (this.stopSubmit = !1),
                this.newsletter.submit());
            }
            checkForChallengePage() {
              this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "newsletter_form_id",
                  this.newsletter.id
                );
            }
            readStorage() {
              this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
              this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
              if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const t = document.getElementById(this.formID),
                  e = t.parentElement.querySelector(Bn),
                  s =
                    -1 !==
                    window.location.search.indexOf("?customer_posted=true"),
                  i =
                    -1 !== window.location.search.indexOf("accepts_marketing");
                s
                  ? (t.classList.remove($n),
                    t.classList.add(Fn),
                    e && (e.classList.add(_n), t.classList.remove(_n)),
                    this.popup && this.cookie.write())
                  : i &&
                    (t.classList.remove(Fn),
                    t.classList.add($n),
                    e && (e.classList.add(_n), t.classList.remove(_n))),
                  (s || i) &&
                    window.addEventListener("load", () => {
                      this.scrollToForm(t);
                    });
              }
            }
            scrollToForm(t) {
              const e = t.getBoundingClientRect();
              (e.top >= 0 &&
                e.left >= 0 &&
                e.bottom <= g() &&
                e.right <= v()) ||
                setTimeout(() => {
                  In(t.getBoundingClientRect().top);
                }, 500);
            }
            unload() {
              this.newsletter.removeEventListener(
                "submit",
                this.newsletterSubmit
              );
            }
            constructor(t) {
              (this.sessionStorage = window.sessionStorage),
                (this.newsletter = t),
                (this.popup = this.newsletter.closest(Dn)),
                this.popup &&
                  (this.cookie = new Hn(
                    this.popup.getAttribute(Nn),
                    "user_has_closed",
                    null
                  )),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                this.isChallengePage || this.init();
            }
          })(t)
        );
      });
    },
    onUnload() {
      Rn[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  Uo("footer", [rn, Wn]);
  const zn = "[data-section-type]",
    Un = "[data-collection-sidebar]",
    Vn = "[data-collection-sidebar-slide-out]",
    jn = "[data-collection-sidebar-close]",
    Xn = "[data-collection-filters-form]",
    Jn = "input",
    Yn = "select",
    Qn = "label",
    Gn = "textarea",
    Kn = "[data-field-price-min]",
    Zn = "[data-field-price-max]",
    tr = "data-field-price-min",
    er = "data-field-price-max",
    sr = "[data-se-min-value]",
    ir = "[data-se-max-value]",
    or = "data-se-min-value",
    nr = "data-se-max-value",
    rr = "data-se-min",
    ar = "data-se-max",
    lr = "[data-show-more]",
    cr = "[data-link-hidden]",
    hr = "[data-collection-nav]",
    dr = "[data-products-grid]",
    ur = "[data-active-filters]",
    pr = "data-active-filters-count",
    mr = "[data-filter-update-url]",
    vr = "[data-sort-enabled]",
    gr = "[data-sort-link]",
    fr = "data-value",
    yr = "[data-popout-toggle]",
    br = "[data-sort-button-text]",
    wr = "[data-results-count]",
    Er = "hidden",
    Sr = "is-focused",
    Lr = "is-loading",
    kr = "is-active";
  let Ar = class extends HTMLElement {
    connectedCallback() {
      this.sort &&
        this.sortLinks.length &&
        this.sortLinks.forEach((t) => {
          t.addEventListener("click", this.onSortButtonClickEvent);
        }),
        this.collectionSidebar &&
          this.form &&
          (this.collectionSidebar.addEventListener(
            "input",
            this.updatePriceEvent
          ),
          this.collectionSidebar.addEventListener(
            "theme:range:update",
            this.updateRangeEvent
          )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.addEventListener("click", this.showMoreEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.addEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.addEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.addEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    collectionSidebarClose(t) {
      t.preventDefault(),
        this.container.dispatchEvent(
          new CustomEvent("theme:filter:close", {
            bubbles: !1,
          })
        );
    }
    onSortButtonClick(t) {
      t.preventDefault(),
        this.sortButton && this.sortButton.dispatchEvent(new Event("click")),
        this.sortActions(t, t.currentTarget);
    }
    sortActions(t, e, s = !0) {
      const i = this.sort.querySelector(br),
        o = this.sort.querySelector(`.${kr}`);
      if (i) {
        const t = e ? e.textContent.trim() : "";
        i.textContent = t;
      }
      o && o.classList.remove(kr),
        this.sort.classList.toggle(kr, e),
        e && (e.parentElement.classList.add(kr), s && this.submitForm(t));
    }
    onSortCheck(t) {
      let e = null;
      if (window.location.search.includes("sort_by")) {
        const t = new window.URL(window.location.href).searchParams;
        for (const [s, i] of t.entries()) {
          const t = this.sort.querySelector(`[${fr}="${i}"]`);
          if (s.includes("sort_by") && t) {
            e = t;
            break;
          }
        }
      }
      this.sortActions(t, e, !1);
    }
    showMore(t) {
      t.preventDefault();
      const e = t.target.matches(lr) ? t.target : t.target.closest(lr);
      e.parentElement.classList.add(Er),
        e.parentElement.previousElementSibling
          .querySelectorAll(cr)
          .forEach((t, e) => {
            t.classList.remove(Er);
            const s = t.querySelector(Jn);
            0 === e &&
              document.body.classList.contains(Sr) &&
              s &&
              (this.collectionSidebarSlideOut || y()
                ? (this.a11y.removeTrapFocus(),
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: s,
                  }))
                : s.focus());
          });
    }
    updatePrice(t) {
      const e = t.type,
        s = t.target;
      if (
        (e === Jn || e === Yn || e === Qn || e === Gn) &&
        this.form &&
        "function" == typeof this.form.submit
      ) {
        const e = this.form.querySelector(Kn),
          i = this.form.querySelector(Zn);
        e &&
          i &&
          (s.hasAttribute(tr) && !i.value
            ? (i.value = i.placeholder)
            : s.hasAttribute(er) && !e.value && (e.value = e.placeholder)),
          this.submitForm(t);
      }
    }
    updateRange(t) {
      if (this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(sr),
          s = this.form.querySelector(ir),
          i = this.form.querySelector(Kn),
          o = this.form.querySelector(Zn);
        if (e && s && i && o && e.hasAttribute(or) && s.hasAttribute(nr)) {
          const n = parseInt(i.placeholder),
            r = parseInt(o.placeholder),
            a = parseInt(e.getAttribute(or)),
            l = parseInt(s.getAttribute(nr));
          (n === a && r === l) ||
            ((i.value = a), (o.value = l), this.submitForm(t));
        }
      }
    }
    filterUpdateFromUrl(t) {
      t.preventDefault(),
        this.submitForm(t, t.currentTarget.getAttribute("href"));
    }
    submitForm(t, e = "") {
      if (!t || (t && "popstate" !== t.type))
        if ("" === e) {
          let t = new window.URL(window.location.href).searchParams;
          const e = t,
            s = Object.fromEntries(e),
            i = t.toString();
          if (
            i.includes("filter.") ||
            i.includes("page=") ||
            i.includes("sort_by=")
          )
            for (const e in s)
              (e.includes("filter.") || "page" === e || "sort_by" === e) &&
                t.delete(e);
          if (this.form) {
            const e = new FormData(this.form),
              s = new URLSearchParams(e),
              i = this.form.querySelector(sr),
              o = this.form.querySelector(ir),
              n = i && i.hasAttribute(rr) ? i.getAttribute(rr) : "",
              r = o && o.hasAttribute(ar) ? o.getAttribute(ar) : "";
            let a = 0;
            for (let [e, i] of s.entries())
              ((e.includes("filter.") && i) || (e.includes("sort_by") && i)) &&
                (t.append(e, i),
                ((i === n && "filter.v.price.gte" === e) ||
                  (i === r && "filter.v.price.lte" === e)) &&
                  (a += 1));
            2 === a &&
              (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
          }
          const o = t.toString(),
            n = o ? `?${o}` : location.pathname;
          window.history.pushState(null, "", n);
        } else window.history.pushState(null, "", e);
      else this.sort && this.onSortCheck(t);
      this.productsContainer &&
        (this.productsContainer.classList.add(Lr),
        fetch(`${window.location.pathname}${window.location.search}`)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html"),
              s = this.container.querySelector(wr);
            if (s) {
              const t = e.querySelector(wr);
              s.innerHTML = t.innerHTML;
            }
            if (
              ((this.productsContainer.innerHTML =
                e.querySelector(dr).innerHTML),
              this.collectionSidebar)
            ) {
              this.collectionSidebar.innerHTML = e.querySelector(Un).innerHTML;
              const t = this.collectionSidebar.querySelector(`[${pr}]`),
                s = this.container.querySelectorAll(ur);
              if (t && s.length) {
                const e = parseInt(t.getAttribute(pr));
                s.forEach((t) => {
                  (t.textContent = e), t.classList.toggle(Er, e < 1);
                });
              }
            }
            this.collectionNav &&
              In(
                this.productsContainer.getBoundingClientRect().top -
                  this.collectionNav.offsetHeight
              ),
              setTimeout(() => {
                this.productsContainer.classList.remove(Lr);
              }, 500);
          })
          .catch((t) => {
            console.log(t);
          }));
    }
    disconnectedCallback() {
      this.collectionSidebar &&
        this.form &&
        (this.collectionSidebar.removeEventListener(
          "input",
          this.updatePriceEvent
        ),
        this.collectionSidebar.removeEventListener(
          "theme:range:update",
          this.updateRangeEvent
        )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.removeEventListener("click", this.showMoreEvent);
          }),
        this.sort &&
          this.sortLinks.length &&
          this.sortLinks.forEach((t) => {
            t.removeEventListener("click", this.onSortButtonClickEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.removeEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.removeEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.removeEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    constructor() {
      super(),
        (this.container = this.closest(zn)),
        (this.collectionSidebar = this.container.querySelector(Un)),
        (this.collectionSidebarSlideOut = this.container.querySelector(Vn)),
        (this.form = this.querySelector(Xn)),
        (this.productsContainer = this.container.querySelector(dr)),
        (this.collectionNav = this.container.querySelector(hr)),
        (this.sort = this.container.querySelector(vr)),
        (this.sortButton = this.container.querySelector(yr)),
        (this.sortLinks = this.container.querySelectorAll(gr)),
        (this.filterUrlButtons = this.container.querySelectorAll(mr)),
        (this.collectionSidebarCloseButtons =
          this.container.querySelectorAll(jn)),
        (this.showMoreOptions = this.querySelectorAll(lr)),
        (this.a11y = R),
        (this.updatePriceEvent = m((t) => this.updatePrice(t), 500)),
        (this.updateRangeEvent = (t) => this.updateRange(t)),
        (this.showMoreEvent = (t) => this.showMore(t)),
        (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
        (this.submitFormEvent = (t) => this.submitForm(t)),
        (this.collectionSidebarCloseEvent = (t) =>
          this.collectionSidebarClose(t)),
        (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t));
    }
  };
  const Cr = "[data-collection-sidebar]",
    Tr = "[data-range-left]",
    qr = "[data-range-right]",
    xr = "[data-range-line]",
    Mr = "[data-range-holder]",
    Pr = "data-se-min",
    Ir = "data-se-max",
    Hr = "data-se-min-value",
    Or = "data-se-max-value",
    Br = "data-se-step",
    Dr = "data-range-filter-update",
    Fr = "[data-field-price-min]",
    $r = "[data-field-price-max]",
    _r = "is-initialized";
  let Nr = class extends HTMLElement {
    connectedCallback() {
      let t = this.min;
      this.hasAttribute(Hr) && (t = parseFloat(this.getAttribute(Hr)));
      let e = this.max;
      this.hasAttribute(Or) && (e = parseFloat(this.getAttribute(Or))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.getAttribute(Br) &&
          (this.step = Math.abs(parseFloat(this.getAttribute(Br)))),
        this.reset(),
        (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.classList.add(_r);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(Hr, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(Or, t);
    }
    onStart(t) {
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : t.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.getAttribute("on-change"))
      ) {
        new Function("min, max", this.getAttribute("on-change"))(
          this.getAttribute(Hr),
          this.getAttribute(Or)
        );
      }
      this.onChange(this.getAttribute(Hr), this.getAttribute(Or));
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(this.getAttribute(Hr), this.getAttribute(Or));
    }
    onChange(t, e) {
      const s = this.closest(Mr);
      if (s) {
        const i = s.querySelector(Fr),
          o = s.querySelector($r);
        i && o && ((i.value = t), (o.value = e));
      }
    }
    onChanged(t, e) {
      this.hasAttribute(Dr) &&
        this.dispatchEvent(
          new CustomEvent("theme:range:update", {
            bubbles: !0,
          })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        s = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(s / this.step)),
          (s = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.setAttribute(Hr, e),
        this.selectedTouch === this.touchRight && this.setAttribute(Or, s);
    }
    onSidebarTransitionEnd(t) {
      t.target == this.sidebar &&
        "min-width" == t.propertyName &&
        (this.sidebar.removeEventListener(
          "transitionend",
          this.sidebarTransitionEvent
        ),
        this.connectedCallback());
    }
    disconnectedCallback() {
      this.sidebar.removeEventListener(
        "transitionend",
        this.sidebarTransitionEvent
      ),
        this.resizeEvent &&
          document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.sidebar = this.closest(Cr)),
        (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
        (this.resizeEvent = () => {
          this.connectedCallback(),
            this.sidebar.addEventListener(
              "transitionend",
              this.sidebarTransitionEvent
            );
        }),
        (this.onMoveEvent = (t) => this.onMove(t)),
        (this.onStopEvent = (t) => this.onStop(t)),
        (this.onStartEvent = (t) => this.onStart(t)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.querySelector(Tr)),
        (this.touchRight = this.querySelector(qr)),
        (this.lineSpan = this.querySelector(xr)),
        (this.min = parseFloat(this.getAttribute(Pr))),
        (this.max = parseFloat(this.getAttribute(Ir))),
        (this.step = 0),
        (this.normalizeFact = 26),
        document.addEventListener("theme:resize:width", this.resizeEvent);
    }
  };
  const Rr = "[data-collection-sidebar]",
    Wr = "[data-collection-sidebar-slide-out]",
    zr = "[data-collection-sidebar-close]",
    Ur = "[data-aria-toggle]",
    Vr = "drawer--animated",
    jr = "expanded",
    Xr = "no-mobile-animation",
    Jr = "is-focused";
  let Yr = {};
  Uo("collection", [
    Pn,
    rn,
    {
      onLoad() {
        Yr[this.id] = new (class {
          init() {
            null !== this.groupTagsButton &&
              (document.addEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.addEventListener(
                "click",
                this.groupTagsButtonClickEvent
              ),
              this.collectionSidebar &&
                setTimeout(() => {
                  this.collectionSidebar.classList.remove(Xr);
                }, 1e3),
              new MutationObserver((t) => {
                for (const e of t)
                  "attributes" === e.type &&
                    "true" == e.target.getAttribute("aria-expanded") &&
                    this.showSidebarCallback();
              }).observe(this.groupTagsButton, {
                attributes: !0,
                childList: !1,
                subtree: !1,
              })),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(jr) ||
                      this.collectionSidebar.classList.remove(Vr);
                  }
                ),
                this.toggleSidebarSlider(),
                this.container.addEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                ));
          }
          showSidebarCallback() {
            const t = this.container.querySelector(Wr),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              s = y();
            this.collectionSidebar.classList.add(Vr),
              null === t &&
                !s &&
                e &&
                (this.a11y.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                  })
                )),
              (s || null !== t) &&
                (t &&
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector(zr),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                  })
                ));
          }
          hideSidebar() {
            const t = this.container.querySelector(Wr),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(jr),
              t && this.a11y.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                  })
                );
          }
          toggleSidebarSlider() {
            y()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(jr) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains(Jr) &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", {
                  bubbles: !0,
                })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebar &&
                this.container.removeEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.collectionSidebar = this.container.querySelector(Rr)),
              (this.groupTagsButton = this.container.querySelector(Ur)),
              (this.a11y = R),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              this.init();
          }
        })(this);
      },
      onUnload() {
        Yr[this.id].onUnload();
      },
    },
    on,
  ]),
    customElements.get("collection-filters-form") ||
      customElements.define("collection-filters-form", Ar),
    customElements.get("range-slider") ||
      customElements.define("range-slider", Nr);
  const Qr = "[data-ticker-scale]",
    Gr = "[data-ticker-text]",
    Kr = "data-clone",
    Zr = "autoplay",
    ta = "speed",
    ea = "ticker--animated",
    sa = "ticker--unloaded",
    ia = "ticker__comparitor",
    oa = 1.63,
    na = 100;
  let ra = class extends HTMLElement {
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener(
          "theme:ticker:refresh",
          m(() => this.checkWidthEvent(), 50)
        ),
        screen.orientation.addEventListener("change", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      this.text = this.querySelector(Gr);
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
        e = this.clientWidth - t < this.comparitor.clientWidth;
      if (e || this.autoplay) {
        var s;
        this.text.classList.remove(ea);
        const i = this.scale.querySelectorAll(`[${Kr}]`),
          o = this.autoplay
            ? parseInt((window.innerWidth - t) / this.text.clientWidth)
            : 2;
        if (
          (null == i ||
            i.forEach((t) => {
              t.remove();
            }),
          this.autoplay || e)
        )
          for (let t = 0; t <= o; t++) {
            const t = this.text.cloneNode(!0);
            t.setAttribute(Kr, ""), this.scale.appendChild(t);
          }
        const n = ((this.text.clientWidth / na) * Number(this.speed)).toFixed(
          2
        );
        this.scale.style.removeProperty("--animation-time"),
          this.scale.style.setProperty("--animation-time", `${n}s`),
          null === (s = this.scale.querySelectorAll(Gr)) ||
            void 0 === s ||
            s.forEach((t) => {
              t.classList.add(ea);
            });
      } else {
        this.text.classList.add(ea);
        this.scale.querySelectorAll(`[${Kr}]`).forEach((t) => {
          t.parentNode.removeChild(t);
        }),
          this.text.classList.remove(ea);
      }
    }
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(Zr)),
        (this.scale = this.querySelector(Qr)),
        (this.text = this.querySelector(Gr)),
        (this.speed = this.hasAttribute(ta) ? this.getAttribute(ta) : oa),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(ia),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(sa),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
  };
  const aa = {
      marquee: ".announcement__bar-holder--marquee",
      slide: "[data-slide]",
      slider: "[data-slider]",
      ticker: "ticker-bar",
      tickerSlide: ".announcement__slide",
    },
    la = "hidden";
  let ca = class extends HTMLElement {
    connectedCallback() {
      this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        this.addEventListener("theme:countdown:hide", (t) => {
          if (window.Shopify.designMode) return;
          const e = t.target.closest(aa.marquee);
          if (1 === this.slidesCount) {
            this.querySelector(aa.ticker).style.display = "none";
          }
          if (e) {
            const e = t.target.closest(aa.tickerSlide);
            this.removeTickerText(e);
          } else {
            const e = t.target.closest(aa.slide);
            this.removeSlide(e);
          }
        }),
        this.addEventListener("theme:countdown:expire", () => {
          var t;
          null === (t = this.querySelectorAll(aa.ticker)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", {
            bubbles: !0,
          })
        );
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          var t;
          null === (t = this.querySelectorAll(aa.tickerBar)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        });
    }
    initSlider() {
      const t = f(),
        e = !t;
      var s, i;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new Mn(this, this.querySelector(aa.slider))),
        null === (i = this.slider.flkty) || void 0 === i || i.reposition());
    }
    removeSlide(t) {
      var e, s;
      null === (e = this.slider.flkty) || void 0 === e || e.remove(t),
        0 ===
          (null === (s = this.slider.flkty) || void 0 === s
            ? void 0
            : s.cells.length) && this.section.classList.add(la);
    }
    removeTickerText(t) {
      const e = t.closest(aa.ticker);
      t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
    constructor() {
      super(),
        (this.slider = this.querySelector(aa.slider)),
        (this.enableSlider = f()),
        (this.slidesCount = this.querySelectorAll(aa.tickerSlide).length),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
  };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", ca),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", ra);
  const ha = "body",
    da = "[data-drawer]",
    ua = "[data-drawer-inner]",
    pa = "[data-drawer-underlay]",
    ma = "[data-stagger-animation]",
    va = "[data-header-wrapper]",
    ga = "data-drawer-toggle",
    fa = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    ya = "drawer--animated",
    ba = "is-open",
    wa = "is-closing",
    Ea = "is-focused";
  let Sa = {};
  const La = {
      onLoad() {
        Sa[this.id] = [];
        this.container.querySelectorAll(da).forEach((t) => {
          Sa[this.id].push(
            new (class {
              connectToggle() {
                this.buttons.forEach((t) => {
                  t.addEventListener("click", () => {
                    this.drawer.dispatchEvent(
                      new CustomEvent("theme:drawer:toggle", {
                        bubbles: !1,
                      })
                    );
                  });
                });
              }
              connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                  this.drawer.classList.contains(ba)
                    ? this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:close", {
                          bubbles: !0,
                        })
                      )
                    : this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:open", {
                          bubbles: !0,
                        })
                      );
                }),
                  document.addEventListener(
                    "theme:cart-drawer:open",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              closers() {
                this.wrapper.addEventListener("keyup", (t) => {
                  "Escape" === t.code && this.hideDrawer();
                }),
                  this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                  });
              }
              showDrawer() {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !0);
                  }),
                  this.drawer.classList.add(ba, ya),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", {
                      bubbles: !0,
                    })
                  ),
                  this.drawerInner &&
                    this.drawerInner.querySelector(this.btnSelector) &&
                    (_(),
                    li(this.drawerInner).then(() => {
                      this.drawer.querySelector(fa).focus(),
                        (this.isAnimating = !1),
                        $(this.drawerInner, {
                          elementToFocus: this.drawerInner.querySelector(
                            this.btnSelector
                          ),
                        });
                    })));
              }
              hideDrawer() {
                this.drawer.classList.contains(ba) &&
                  !this.isAnimating &&
                  ((this.isAnimating = !0),
                  this.drawer.classList.add(wa),
                  this.drawer.classList.remove(ba),
                  _(),
                  this.body.classList.contains(Ea) &&
                    this.buttons.length &&
                    this.buttons[0].focus(),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !1);
                  }),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", {
                      bubbles: !0,
                    })
                  ),
                  li(this.drawerInner).then(() => {
                    this.drawer.classList.remove(wa, ya),
                      (this.isAnimating = !1),
                      document.dispatchEvent(
                        new CustomEvent("theme:sliderule:close", {
                          bubbles: !1,
                        })
                      );
                  }));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:cart-drawer:open",
                  this.hideDrawer
                ),
                  document.removeEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.removeEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              constructor(t) {
                (this.isAnimating = !1),
                  (this.drawer = t),
                  (this.drawerWrapper = this.drawer.closest(da)),
                  (this.drawerInner = this.drawer.querySelector(ua)),
                  (this.underlay = this.drawer.querySelector(pa)),
                  (this.wrapper = this.drawer.closest(va)),
                  (this.key = this.drawer.dataset.drawer),
                  (this.btnSelector = `[${ga}='${this.key}']`),
                  (this.buttons = document.querySelectorAll(this.btnSelector)),
                  (this.staggers = this.drawer.querySelectorAll(ma)),
                  (this.body = document.querySelector(ha)),
                  (this.showDrawer = this.showDrawer.bind(this)),
                  (this.hideDrawer = this.hideDrawer.bind(this)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers();
              }
            })(t)
          );
        });
      },
      onUnload() {
        Sa[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    ka = ".page-header",
    Aa = "js__header__stuck",
    Ca = "has-header-sticky",
    Ta = "shopify-section-group-header-group",
    qa = "data-header-sticky",
    xa = "data-scroll-locked";
  let Ma = {};
  const Pa = {
      onLoad() {
        Ma = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains(Ta) &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(ka)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(Aa), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute(xa) ||
              (this.cls.remove(Aa), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute(qa)),
              document.body.classList.toggle(Ca, this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(ka)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof Ma.unload && Ma.unload();
      },
    },
    Ia = "data-hover-disclosure-toggle",
    Ha = "[data-hover-disclosure]",
    Oa = "[data-top-link]",
    Ba = "[data-header-wrapper]",
    Da = "[data-stagger]",
    Fa = "[data-stagger-first]",
    $a = "[data-stagger-second]",
    _a = "is-visible",
    Na = "meganav--visible",
    Ra = "meganav--is-transitioning";
  let Wa = {},
    za = {};
  const Ua = {
      onLoad() {
        (Wa[this.id] = []),
          (za = this.container.querySelectorAll(Ha)),
          za.forEach((t) => {
            Wa[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(Ra),
                    this.grandparent
                      ? this.wrapper.classList.add(Na)
                      : this.wrapper.classList.remove(Na),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(_a),
                    this.disclosure.classList.add(_a),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(Ra);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(_a),
                    this.trigger.classList.remove(_a),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(Na, Ra);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(Da).forEach((t, e) => {
                    t.style.transitionDelay = 50 * e + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(Fa).forEach((t, e) => {
                      const s = 100 * e;
                      (t.style.transitionDelay = `${s}ms`),
                        t.parentElement.querySelectorAll($a).forEach((t, e) => {
                          const i = 20 * (e + 1);
                          t.style.transitionDelay = `${s + i}ms`;
                        });
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(_a) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    {
                      passive: !0,
                    }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest(Ba)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[${Ia}='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector(Oa)),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        Wa[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Wa[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    Va = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    ja = "is-visible",
    Xa = "is-hiding",
    Ja = "is-hidden",
    Ya = "is-focused",
    Qa = "is-scrolling";
  let Ga = {};
  const Ka = {
      onLoad() {
        Ga[this.id] = [];
        this.container.querySelectorAll(Va.slideruleWrappper).forEach((t) => {
          Ga[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener("click", () => {
                  (this.cachedButton = this.trigger), this.showSliderule();
                }),
                  this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.hideSliderule();
                    });
                  });
              }
              keyboardEvents() {
                this.sliderule.addEventListener("keyup", (t) => {
                  t.stopPropagation(),
                    "Escape" === t.code && this.hideSliderule();
                });
              }
              trapFocusSliderule(t = !0) {
                const e = t
                  ? this.sliderule.querySelector(this.exitSelector)
                  : this.cachedButton;
                this.accessibility.removeTrapFocus(),
                  e &&
                    this.drawerContent &&
                    this.accessibility.trapFocus(this.drawerContent, {
                      elementToFocus: document.body.classList.contains(Ya)
                        ? e
                        : null,
                    });
              }
              hideSliderule(t = !1) {
                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(Va.sliderulePane, e),
                  this.pane.classList.add(Xa),
                  this.sliderule.classList.add(Xa);
                const s = t
                    ? `[${Va.dataAnimates}].${Ja}`
                    : `[${Va.dataAnimates}="${e}"]`,
                  i = this.pane.querySelectorAll(s);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(Ja);
                  });
                const o = t
                  ? this.pane.querySelectorAll(`.${ja}, .${Xa}`)
                  : this.children;
                o.forEach((s, i) => {
                  const n = o.length - 1 == i;
                  s.classList.remove(ja),
                    t &&
                      (s.classList.remove(Xa), this.pane.classList.remove(Xa));
                  const r = () => {
                    parseInt(this.pane.getAttribute(Va.sliderulePane)) === e &&
                      this.sliderule.classList.remove(ja),
                      this.sliderule.classList.remove(Xa),
                      this.pane.classList.remove(Xa),
                      n &&
                        (this.accessibility.removeTrapFocus(),
                        t || this.trapFocusSliderule(!1)),
                      s.removeEventListener("animationend", r);
                  };
                  window.theme.settings.enableAnimations
                    ? s.addEventListener("animationend", r)
                    : r();
                });
              }
              showSliderule() {
                let t = null;
                const e = this.sliderule.closest(`.${ja}`);
                let s = this.pane;
                e && (s = e),
                  s.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  }),
                  s.classList.add(Qa);
                const i = () => {
                  s.scrollTop <= 0
                    ? (s.classList.remove(Qa), t && cancelAnimationFrame(t))
                    : (t = requestAnimationFrame(i));
                };
                (t = requestAnimationFrame(i)),
                  this.sliderule.classList.add(ja);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                  n = o + 1;
                this.pane.setAttribute(Va.sliderulePane, n);
                const r = this.pane.querySelectorAll(
                  `[${Va.dataAnimates}="${o}"]`
                );
                r.length &&
                  r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(Xa);
                    const i = () => {
                      t.classList.remove(Xa),
                        parseInt(this.pane.getAttribute(Va.sliderulePane)) !==
                          o && t.classList.add(Ja),
                        s && this.trapFocusSliderule(),
                        t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations
                      ? t.addEventListener("animationend", i)
                      : i();
                  });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(Va.sliderulePane) &&
                  parseInt(this.pane.getAttribute(Va.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(Va.sliderulePane)) > 0 &&
                    this.pane.setAttribute(Va.sliderulePane, 0));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:sliderule:close",
                  this.closeSliderule
                );
              }
              constructor(t) {
                (this.sliderule = t), (this.key = this.sliderule.id);
                const e = `[${Va.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${Va.slideruleClose}='${this.key}']`),
                  (this.trigger = document.querySelector(e)),
                  (this.exit = document.querySelectorAll(this.exitSelector)),
                  (this.pane = document.querySelector(`[${Va.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    Va.children
                  )),
                  (this.drawerContent = document.querySelector(
                    Va.drawerContent
                  )),
                  (this.cachedButton = null),
                  (this.accessibility = R),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  (this.closeSliderule = this.closeSliderule.bind(this)),
                  this.clickEvents(),
                  this.keyboardEvents(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
              }
            })(t)
          );
        });
      },
      onUnload() {
        Ga[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Za = "[data-takes-space-wrapper]",
    tl = "[data-child-takes-space]",
    el = "[data-header-desktop]",
    sl = '.navlink[href="#"]',
    il = "cart-drawer",
    ol = "[data-cart-toggle]",
    nl =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    rl = "js__header__clone",
    al = "has-first-section-overlay-header",
    ll = "js__show__mobile",
    cl = "has-header-transparent",
    hl = "data-header-transparent";
  let dl = {};
  Uo("header", [
    {
      onLoad() {
        dl = new (class {
          initTicker(t = !1) {
            this.tickerFrames.forEach((e) => {
              new ra(e, t);
            }),
              (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
              document.addEventListener(
                "theme:resize:width",
                this.tickerResizeEvent
              );
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
              this.wrapper.classList.add(ll);
              const { headerHeight: t } = l();
              document.documentElement.style.setProperty(
                "--header-height",
                `${t}px`
              );
            } else this.wrapper.classList.remove(ll);
          }
          getMinWidth() {
            const t = this.wrapper.cloneNode(!0);
            t.classList.add(rl), document.body.appendChild(t);
            const e = t.querySelectorAll(Za);
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll(tl);
                let o = 0;
                (o =
                  3 === e.length
                    ? (function (t) {
                        let e = [];
                        return (
                          t.forEach((t) => {
                            t.firstElementChild &&
                              e.push(t.firstElementChild.clientWidth);
                          }),
                          e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                          e.reduce((t, e) => t + e)
                        );
                      })(e)
                    : (function (t) {
                        let e = 0;
                        return (
                          t.forEach((t) => {
                            e += t.clientWidth;
                          }),
                          e
                        );
                      })(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            var t;
            "drawer" === theme.settings.cartType &&
              (null === (t = this.wrapper.querySelectorAll(ol)) ||
                void 0 === t ||
                t.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    const s = document.querySelector(il);
                    s &&
                      (e.preventDefault(),
                      s.dispatchEvent(
                        new CustomEvent("theme:cart-drawer:show")
                      ),
                      (window.accessibility.lastElement = t));
                  });
                }));
          }
          toggleButtonClick(t) {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:toggle", {
                  bubbles: !0,
                })
              );
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(el)),
              (this.deadLinks = document.querySelectorAll(sl)),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            const e = document.querySelector(nl);
            document.body.classList.toggle(cl, this.wrapper.hasAttribute(hl)),
              document.body.classList.toggle(al, e);
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof dl.unload && dl.unload();
      },
    },
    La,
    Ka,
    Pa,
    Ua,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", ra);
  const ul = "[data-block-scroll]",
    pl = "flickity-enabled",
    ml = {};
  const vl = {
      onLoad() {
        ml[this.id] = new (class {
          onBlockSelect(t) {
            const e = this.container.querySelector(ul);
            if (e && !e.classList.contains(pl)) {
              const s = t.srcElement;
              s &&
                e.scrollTo({
                  top: 0,
                  left: s.offsetLeft,
                  behavior: "smooth",
                });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        ml[this.id].onBlockSelect(t);
      },
    },
    gl = "[data-slider-mobile]",
    fl = "[data-slide]",
    yl = "[data-slider-thumb]",
    bl = "[data-slider-container]",
    wl = "[data-popup-container]",
    El = "[data-popup-close]",
    Sl = "is-animating",
    Ll = "is-open",
    kl = "data-slider-thumb",
    Al = {};

  function Cl() {
    this.entries = [];
  }

  function Tl(t, e) {
    ql(t);
    var s = (function (t, e) {
      ql(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      return (
        ql(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, s) {
            return t.options[s] === e;
          });
        })[0] || null
      );
    })(t, s);
  }

  function ql(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  Uo("look", [
    {
      onLoad() {
        Al[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(Sl),
                  t.target.classList.contains(Ll)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(Sl);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(Ll),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0,
                      })
                    );
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                  s.preventDefault();
                  const i =
                      t.hasAttribute(kl) && "" !== t.getAttribute(kl)
                        ? parseInt(t.getAttribute(kl))
                        : e,
                    o = this.slides[i];
                  if (y()) {
                    const t = parseInt(
                      window.getComputedStyle(this.slider).paddingLeft
                    );
                    this.slider.scrollTo({
                      top: 0,
                      left: o.offsetLeft - t,
                      behavior: "auto",
                    }),
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", {
                          bubbles: !0,
                        })
                      ),
                      this.popupContainer.classList.add(Sl, Ll);
                  } else {
                    let { stickyHeaderHeight: t } = l();
                    const e = o.getBoundingClientRect().top,
                      s = o.offsetHeight / 2,
                      i = window.innerHeight,
                      n = i / 2,
                      r = this.container.querySelector(bl);
                    let a = e + s - n + window.scrollY;
                    if (r) {
                      const e = r.getBoundingClientRect().top + window.scrollY,
                        s = e + r.offsetHeight;
                      a < e ? (a = e - t) : a + i > s && (a = s - i);
                    }
                    window.scrollTo({
                      top: a,
                      left: 0,
                      behavior: "smooth",
                    });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(Ll);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              {
                once: !0,
              }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                {
                  once: !0,
                }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              {
                once: !0,
              }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                {
                  once: !0,
                }
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(gl)),
              (this.slides = this.container.querySelectorAll(fl)),
              (this.thumbs = this.container.querySelectorAll(yl)),
              (this.popupContainer = this.container.querySelector(wl)),
              (this.popupClose = this.container.querySelectorAll(El)),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    vl,
  ]),
    (Cl.prototype.add = function (t, e, s) {
      this.entries.push({
        element: t,
        event: e,
        fn: s,
      }),
        t.addEventListener(e, s);
    }),
    (Cl.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var xl = '[name="id"]',
    Ml = '[name="selling_plan"]',
    Pl = '[name^="options"]',
    Il = '[name="quantity"]',
    Hl = '[name^="properties"]';
  const Ol = "data-scrollbar",
    Bl = "data-scrollbar-slider",
    Dl = "data-scrollbar-slide-fullwidth",
    Fl = "[data-scrollbar-arrow-prev]",
    $l = "[data-scrollbar-arrow-next]",
    _l = "is-hidden",
    Nl = 200;
  let Rl = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(Dl)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(_l), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(Dl)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(_l), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        var t;
        null === (t = this.arrowNext) ||
          void 0 === t ||
          t.classList.toggle(
            _l,
            Math.round(
              this.scrollbar.scrollLeft +
                this.scrollbar.getBoundingClientRect().width +
                1
            ) >= this.scrollbar.scrollWidth
          );
      }, Nl);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(_l, this.scrollbar.scrollLeft <= 0);
      }, Nl);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({
        top: 0,
        left: t,
        behavior: "smooth",
      });
    }
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector($l)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(Fl)),
        this.scrollbar.hasAttribute(Ol) && (this.init(), this.listen()),
        this.scrollbar.hasAttribute(Bl) && this.scrollToVisibleElement();
    }
  };
  const Wl = "[data-grid-swatch-form]",
    zl = "[data-grid-item]",
    Ul = "[data-product-information]",
    Vl = "[data-product-image]",
    jl = "[data-swatch-button]",
    Xl = "[data-swatch-link]",
    Jl = "[data-swatch-text]",
    Yl = "[data-swatch-template]",
    Ql = "is-visible",
    Gl = "no-events",
    Kl = "swatch",
    Zl = "data-swatch-handle",
    tc = "data-swatch-label",
    ec = "data-scrollbar",
    sc = "data-swatch-count",
    ic = "data-tooltip",
    oc = "data-swatch-variant-name",
    nc = "data-variant-title",
    rc = "data-swatch-values";
  let ac = class extends HTMLElement {
      connectedCallback() {
        this.hasAttribute(ic) && new sn(this);
      }
      constructor() {
        super();
      }
    },
    lc = class extends HTMLElement {
      connectedCallback() {
        (this.handle = this.getAttribute(Zl)),
          (this.productItem = this.closest(zl)),
          (this.productInfo = this.closest(Ul)),
          (this.productImage = this.productItem.querySelector(Vl)),
          (this.template = document.querySelector(Yl).innerHTML),
          (this.swatchesJSON = this.getSwatchesJSON()),
          (this.swatchesStyle = theme.settings.collectionSwatchStyle);
        const t = this.getAttribute(tc).trim().toLowerCase();
        (function (t) {
          const e = `${window.theme.routes.root}products/${t}.js`;
          return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
              console.error(t);
            });
        })(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === t || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
      init() {
        if (
          ((this.innerHTML = ""),
          (this.count = 0),
          (this.limitedCount = 0),
          this.swatches.forEach((t) => {
            let e = null,
              s = !1,
              i = "";
            for (const s of this.product.variants) {
              const o = s.options.includes(t);
              if ((!e && o && (e = s), o && s.featured_media)) {
                (i = s.featured_media.preview_image.src), (e = s);
                break;
              }
            }
            for (const e of this.product.variants) {
              if (e.options.includes(t) && e.available) {
                s = !0;
                break;
              }
            }
            if (e) {
              const r = document.createElement("div");
              r.innerHTML = this.template;
              const a = r.querySelector(jl),
                l = r.querySelector(Xl),
                c = r.querySelector(Jl),
                h = this.swatchesJSON[t],
                d = "native" == theme.settings.swatchesType ? h : `var(--${h})`,
                u = e.title.replaceAll('"', "'");
              (a.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
                a.classList.add(`${Kl}-${h}`),
                (a.dataset.tooltip = t),
                (a.dataset.swatchVariant = e.id),
                (a.dataset.swatchVariantName = u),
                (a.dataset.swatchImage = i),
                (a.dataset.variant = e.id),
                a.style.setProperty("--swatch", d),
                (l.href =
                  ((o = this.product.url),
                  (n = e.id),
                  /variant=/.test(o)
                    ? o.replace(/(variant=)[^&]+/, "$1" + n)
                    : /\?/.test(o)
                    ? o.concat("&variant=").concat(n)
                    : o.concat("?variant=").concat(n))),
                (l.dataset.swatch = t),
                (l.disabled = !s),
                (c.innerText = t),
                "limited" != this.swatchesStyle
                  ? (this.innerHTML += r.innerHTML)
                  : this.count <= 4 &&
                    ((this.innerHTML += r.innerHTML), this.limitedCount++),
                this.count++;
            }
            var o, n;
          }),
          (this.swatchCount = this.productInfo.querySelector(`[${sc}]`)),
          (this.swatchElements = this.querySelectorAll(Xl)),
          (this.swatchForm = this.productInfo.querySelector(Wl)),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(sc))
        ) {
          if (
            "text" == this.swatchesStyle ||
            "text-slider" == this.swatchesStyle
          ) {
            if (
              ((this.swatchCount.innerText = `${this.count} ${
                this.count > 1
                  ? theme.strings.otherColor
                  : theme.strings.oneColor
              }`),
              "text" == this.swatchesStyle)
            )
              return;
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productInfo.classList.add(Gl),
                this.swatchForm.classList.add(Ql);
            }),
              this.productInfo.addEventListener("mouseleave", () => {
                this.hideSwatchesTimer = setTimeout(() => {
                  this.productInfo.classList.remove(Gl),
                    this.swatchForm.classList.remove(Ql);
                }, 100);
              });
          }
          if (
            (("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) ||
              this.swatchForm.classList.add(Ql),
            "limited" == this.swatchesStyle)
          ) {
            const t = this.count - this.limitedCount;
            this.swatchForm.classList.add(Ql),
              t > 0 &&
                (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
          }
        }
        ("text-slider" != this.swatchesStyle &&
          "slider" != this.swatchesStyle) ||
          (this.hasAttribute(ec) && new Rl(this)),
          this.bindSwatchButtonEvents();
      }
      bindSwatchButtonEvents() {
        var t;
        null === (t = this.querySelectorAll(jl)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("mouseenter", this.showVariantImageEvent),
              t.hasAttribute(ic) && new sn(t);
          }),
          this.productItem.addEventListener(
            "mouseleave",
            this.productItemMouseLeaveEvent
          );
      }
      showVariantImage(t) {
        var e;
        const s =
            null === (e = t.target.getAttribute(oc)) || void 0 === e
              ? void 0
              : e.replaceAll('"', "'"),
          i = this.productImage.querySelectorAll(`[${nc}]`),
          o = this.productImage.querySelector(`[${nc}="${s}"]`);
        null == i ||
          i.forEach((t) => {
            t.classList.remove(Ql);
          }),
          null == o || o.classList.add(Ql);
      }
      hideVariantImages() {
        var t;
        null === (t = this.productImage.querySelectorAll(`[${nc}].${Ql}`)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.classList.remove(Ql);
          });
      }
      getSwatchesJSON() {
        if (!this.hasAttribute(rc)) return {};
        const t = this.getAttribute(rc).split(","),
          e = {};
        return (
          null == t ||
            t.forEach((t) => {
              const [s, i] = t.split(":");
              e[s.trim()] = i.trim();
            }),
          e
        );
      }
      constructor() {
        super(),
          (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
          (this.showVariantImageEvent = (t) => this.showVariantImage(t));
      }
    };
  const cc = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    hc = "is-visible",
    dc = "is-fade",
    uc = "no-events",
    pc = "is-active",
    mc = "data-sibling-cutline",
    vc = "data-sibling-image",
    gc = "data-sibling-link",
    fc = "data-sibling-price",
    yc = "data-product-link";
  let bc = class extends HTMLElement {
    connectedCallback() {
      (this.product = this.closest(cc.productGridItem)),
        (this.siblingScrollbar = this.querySelector(cc.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(cc.siblingCount)),
        (this.siblingFieldset = this.querySelector(cc.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(cc.siblingLink)),
        (this.productInfo = this.closest(cc.productInfo)),
        (this.productLink = this.closest(cc.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        this.initScrollbar(),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" != this.swatchesStyle &&
            "slider" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
            this.siblingFieldset.classList.add(hc),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(yc)
                ? this.productLinks[0].getAttribute(yc)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(pc),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  ((this.productCutline.innerHTML = this.productCutlineValue),
                  (this.productCutline.title = this.productCutlineValue)),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                s = e.hasAttribute(gc) ? e.getAttribute(gc) : "",
                i = e.hasAttribute(fc) ? e.getAttribute(fc) : "",
                o = e.hasAttribute(mc) ? e.getAttribute(mc) : "",
                n = e.hasAttribute(vc) ? e.getAttribute(vc) : "";
              s &&
                this.productLinks.forEach((t) => {
                  t.href = s;
                }),
                i &&
                  (this.productPrice.innerHTML = `<span class="price">${i}</span>`),
                this.productCutline &&
                  (o
                    ? ((this.productCutline.innerHTML = o),
                      (this.productCutline.title = o))
                    : ((this.productCutline.innerHTML = ""),
                      (this.productCutline.title = ""))),
                n && this.showSiblingImage(n);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const e = window.devicePixelRatio || 1,
                s = this.productImage.offsetWidth * e,
                i = 180 * Math.ceil(s / 180),
                o = n.getSizedImageUrl(t, `${i}x`),
                r = this.productImageSibling.querySelector(`[src="${o}"]`),
                a = () => {
                  this.productImageSibling.classList.add(hc),
                    this.productImageSibling
                      .querySelector(`[src="${o}"]`)
                      .classList.add(dc);
                },
                l = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(dc);
                    }),
                    requestAnimationFrame(a);
                };
              if (r) l();
              else {
                const t = document.createElement("img");
                (t.src = o),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), l();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(hc),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove(dc);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  cc.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  cc.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  cc.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  cc.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  cc.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product),
        this.querySelectorAll(cc.tooltip).forEach((t) => {
          new sn(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(uc),
        "text" != this.swatchesStyle && this.siblingFieldset.classList.add(hc);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(uc),
          this.siblingFieldset.classList.remove(hc);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new Rl(this.siblingScrollbar);
    }
    constructor() {
      super();
    }
  };
  const wc = "body",
    Ec = "[data-related-section]",
    Sc = "[data-tabs-holder]",
    Lc = "data-tab",
    kc = "data-tab-index",
    Ac = "[data-aos]",
    Cc = "data-block-id",
    Tc = "[data-tab]",
    qc = ".tab-link",
    xc = ".tab-link__recent",
    Mc = ".tab-content",
    Pc = "[data-scrollbar]",
    Ic = "current",
    Hc = "hidden",
    Oc = "aos-animate",
    Bc = "aos-no-transition",
    Dc = "is-focused",
    Fc = {};
  const $c = {
    onLoad() {
      Fc[this.id] = [];
      this.container.querySelectorAll(Sc).forEach((t) => {
        Fc[this.id].push(
          new (class {
            init() {
              const t = this.container.querySelectorAll(Tc);
              this.container.addEventListener("theme:tab:check", () =>
                this.checkRecentTab()
              ),
                this.container.addEventListener("theme:tab:hide", () =>
                  this.hideRelatedTab()
                ),
                t.length &&
                  t.forEach((t) => {
                    const e = parseInt(t.getAttribute(Lc)),
                      s = this.container.querySelector(`${Mc}-${e}`);
                    t.addEventListener("click", () => {
                      this.tabChange(t, s);
                    }),
                      t.addEventListener("keyup", (e) => {
                        ("Space" !== e.code && "Enter" !== e.code) ||
                          !this.body.classList.contains(Dc) ||
                          this.tabChange(t, s);
                      });
                  });
            }
            tabChange(t, e) {
              if (t.classList.contains(Ic)) return;
              const s = this.container.querySelector(`${Tc}.${Ic}`),
                i = this.container.querySelector(`${Mc}.${Ic}`);
              null == s || s.classList.remove(Ic),
                null == i || i.classList.remove(Ic),
                t.classList.add(Ic),
                e.classList.add(Ic),
                t.classList.contains(Hc) && e.classList.add(Hc),
                this.accessibility.a11y.removeTrapFocus(),
                this.container.dispatchEvent(
                  new CustomEvent("theme:tab:change", {
                    bubbles: !0,
                  })
                ),
                t.dispatchEvent(
                  new CustomEvent("theme:form:sticky", {
                    bubbles: !0,
                    detail: {
                      element: "tab",
                    },
                  })
                ),
                this.animateItems(e);
            }
            animateItems(t, e = !0) {
              const s = t.querySelectorAll(Ac);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(Oc),
                    e &&
                      (t.classList.add(Bc),
                      requestAnimationFrame(() => {
                        t.classList.remove(Bc), t.classList.add(Oc);
                      }));
                });
            }
            initNativeScrollbar() {
              this.scrollbarHolder.length &&
                this.scrollbarHolder.forEach((t) => {
                  new Rl(t);
                });
            }
            checkRecentTab() {
              const t = this.container.querySelector(xc);
              if (t) {
                t.classList.remove(Hc);
                const e = parseInt(t.getAttribute(Lc)),
                  s = this.container.querySelector(`${Mc}[${kc}="${e}"]`);
                s && (s.classList.remove(Hc), this.animateItems(s, !1)),
                  this.initNativeScrollbar();
              }
            }
            hideRelatedTab() {
              const t = this.container.querySelector(Ec);
              if (!t) return;
              const e = t.closest(`${Mc}.${Ic}`);
              if (!e) return;
              const s = parseInt(e.getAttribute(kc)),
                i = this.container.querySelectorAll(Tc);
              if (i.length > s) {
                const t = i[s].nextSibling;
                t &&
                  (i[s].classList.add(Hc),
                  t.dispatchEvent(new Event("click")),
                  this.initNativeScrollbar());
              }
            }
            onBlockSelect(t) {
              const e = this.container.querySelector(
                `${qc}[${Cc}="${t.detail.blockId}"]`
              );
              e &&
                (e.dispatchEvent(new Event("click")),
                e.parentNode.scrollTo({
                  top: 0,
                  left: e.offsetLeft - e.clientWidth,
                  behavior: "smooth",
                }));
            }
            constructor(t) {
              (this.container = t),
                (this.body = document.querySelector(wc)),
                (this.accessibility = window.accessibility),
                this.container &&
                  ((this.scrollbarHolder = this.container.querySelectorAll(Pc)),
                  this.init(),
                  this.initNativeScrollbar());
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      Fc[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };

  function _c() {
    const t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  const Nc = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    Rc = 3e3,
    Wc = "[data-animation]",
    zc = "[data-api-content]",
    Uc = "[data-quick-add-btn]",
    Vc = "[data-add-to-cart]",
    jc = "cart-drawer",
    Xc = "[data-cart-page]",
    Jc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Yc = "[data-message-error]",
    Qc = "[data-quick-add-modal-handle]",
    Gc = "[data-product-upsell-ajax]",
    Kc = "[data-quick-add-modal-close]",
    Zc = "data-grid-item",
    th = "[data-product-information]",
    eh = "[data-quick-add-holder]",
    sh = "[data-quick-add-modal]",
    ih = "[data-quick-add-modal-template]",
    oh = "closing",
    nh = "data-product-id",
    rh = "data-quick-add-modal-handle",
    ah = "data-sibling-swapper",
    lh = "data-quick-add-holder";
  let ch = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.cart &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.accessibility.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: {
                    button: this.buttonATC,
                  },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(ah),
        s = this.modalButton.classList.contains(Nc.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(Nc.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(sh)),
          this.currentModal.classList.add(Nc.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${sh}[${nh}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(ih);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(sh)),
          e.remove(),
          (this.modal = document.querySelector(
            `${sh}[${nh}="${this.productId}"]`
          )),
          (this.modal.querySelector(Gc).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(zc).innerHTML),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", {
            bubbles: !1,
          })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(Nc.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(Nc.loading),
          (this.modalButton.disabled = !1),
          (window.accessibility.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Wc).forEach((t) => {
            t.classList.add(Nc.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", {
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
          })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          {
            once: !0,
          }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(oh))
          return this.modal.setAttribute(oh, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(oh),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(Nc.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(Nc.disabled) &&
            this.quickAddHolder.classList.remove(Nc.disabled),
          this.resetAnimatedItems(),
          _c() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
              })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(Kc)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(oh)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(Jc);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Nc.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${Zc}]`);
        if (!s) return;
        const i = e.querySelector(Yc),
          o = s.classList.contains(Nc.overlayText),
          n = s.querySelector(th),
          r = e.querySelector(Vc);
        r &&
          (r.classList.remove(Nc.added, Nc.loading), e.classList.add(Nc.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(Nc.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(Nc.hidden);
          }, Rc);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Nc.visible, Nc.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(Nc.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), P(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ze({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(Wc).forEach((t) => {
          t.classList.remove(Nc.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.container = this),
      (this.cart = document.querySelector(jc) || document.querySelector(Xc)),
      (this.quickAddHolder = this.container.querySelector(eh)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(lh)),
        (this.modalButton = this.quickAddHolder.querySelector(Qc)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(rh)),
        (this.cartDrawer = document.querySelector(jc)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(Uc)),
        (this.buttonATC = this.quickAddHolder.querySelector(Vc)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = R),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  Uo("product-grid", [$c]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", ch),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ac),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", lc),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", bc);
  const hh = "complementary-products",
    dh = "quick-add-product",
    uh = "is-loaded",
    ph = "data-url";
  let mh = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(ph) &&
              "" !== this.getAttribute(ph) &&
              fetch(this.getAttribute(ph))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const s = e.querySelector(hh);
                  s &&
                    s.innerHTML.trim().length &&
                    (this.innerHTML = s.innerHTML),
                    e.querySelector(`${hh} ${dh}`) && this.classList.add(uh);
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        {
          rootMargin: "0px 0px 400px 0px",
        }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const vh = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    gh = 'input[type="email"]',
    fh = 'input[type="checkbox"]',
    yh = "[data-form-wrapper]";
  let bh = class extends HTMLElement {
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(fh)),
        (this.fieldEmail = this.querySelector(gh)),
        (this.fields = this.querySelectorAll(vh)),
        (this.form = this.closest(yh)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
  };
  const wh = ".product__page",
    Eh = "[data-form-wrapper]",
    Sh = "[data-header-sticky]",
    Lh = "[data-product-media-list]",
    kh = "is-sticky",
    Ah = "data-sticky-enabled";
  window.theme.variables = {
    productPageSticky: !1,
  };
  const Ch = {};
  const Th = {
      onLoad() {
        Ch[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          stickyFormEvents(t) {
            this.removeAnimationFrameSticky(),
              (this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition(t)
              ));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.formWrapper.removeEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t = this.container.querySelector(`${wh} ${Eh}`);
            if (t)
              if (f()) {
                const e = this.container.querySelector(Eh),
                  s = this.container.querySelector(Lh);
                if (!e || !s) return;
                e.offsetHeight < s.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    t.classList.add(kh))
                  : ((theme.variables.productPageSticky = !1),
                    t.classList.remove(kh));
              } else
                (theme.variables.productPageSticky = !1),
                  t.classList.remove(kh);
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrameSticky();
            const e = Boolean(t && t.detail),
              s = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              i = this.formWrapper.offsetHeight,
              o = window.innerHeight - i - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (
              (this.scrollDirectionDown
                ? (this.stickyScrollTop -= n)
                : (this.stickyScrollTop += n),
              this.stickyFormLoad)
            ) {
              if (document.querySelector(Sh)) {
                let { headerHeight: t } = l();
                this.stickyDefaultTop = t;
              } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
              this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(
              Math.max(this.stickyScrollTop, o),
              this.stickyDefaultTop
            );
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (s && this.onChangeCounter <= 10) ||
              (s && this.stickyFormLastHeight !== i) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (s && (this.onChangeCounter += 1),
                  s &&
                    this.stickyFormLastHeight !== i &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky &&
                  this.removeAnimationFrameSticky(),
              (this.stickyFormLastHeight = i);
          }
          removeAnimationFrameSticky() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(Ah)),
              (this.formWrapper = this.container.querySelector(Eh)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        Ch[this.id].onUnload();
      },
    },
    qh = "data-section-type",
    xh = "[data-share-button]",
    Mh = "[data-share-message]",
    Ph = "is-visible";
  let Ih = class extends HTMLElement {
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({
              url: this.urlToShare,
              title: document.title,
            });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(qh) &&
        this.container.addEventListener("theme:variant:change", (t) => {
          t.detail.variant &&
            (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              t.detail.variant.id
            }`);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(Ph);
        const t = () => {
          this.shareMessage.classList.remove(Ph),
            this.shareMessage.removeEventListener("animationend", t);
        };
        this.shareMessage.addEventListener("animationend", t);
      });
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${qh}]`)),
        (this.shareButton = this.querySelector(xh)),
        (this.shareMessage = this.querySelector(Mh)),
        (this.urlToShare = this.shareButton.dataset.shareUrl
          ? this.shareButton.dataset.shareUrl
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const Hh = "[data-button-arrow]",
    Oh = "[data-deferred-media-button]",
    Bh = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    Dh = "[data-image-id]",
    Fh = "[data-product-media-list]",
    $h = "[data-section-type]",
    _h = "slider__arrows",
    Nh = "is-dragging",
    Rh = "is-focused",
    Wh = "media--active",
    zh = "media--hidden",
    Uh = "media--hiding",
    Vh = "data-active-media",
    jh = "data-button-prev",
    Xh = "data-button-next",
    Jh = "data-image-id",
    Yh = "data-media-id",
    Qh = "data-fader-desktop",
    Gh = "data-fader-mobile";
  let Kh = class extends HTMLElement {
    connectedCallback() {
      1 !== Object.keys(this.productMediaItems).length &&
        (this.productMediaObserver(),
        this.toggleEvents(),
        this.listen(),
        this.setHeight());
    }
    disconnectedCallback() {
      this.unlisten();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.toggleEvents),
        document.addEventListener("theme:resize:width", this.setHeight),
        this.addEventListener("theme:media:select", this.selectMediaEvent);
    }
    unlisten() {
      document.removeEventListener("theme:resize:width", this.toggleEvents),
        document.removeEventListener("theme:resize:width", this.setHeight),
        this.removeEventListener("theme:media:select", this.selectMediaEvent);
    }
    toggleEvents() {
      const t = y();
      (t && this.hasAttribute(Gh)) || (!t && this.hasAttribute(Qh))
        ? this.bindEventListeners()
        : this.unbindEventListeners();
    }
    bindEventListeners() {
      this.initialized ||
        (this.productMediaList.addEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
        this.productMediaList.addEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.addEventListener(
          "touchstart",
          this.handleMouseDown,
          {
            passive: !0,
          }
        ),
        this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
          passive: !0,
        }),
        this.productMediaList.addEventListener(
          "touchmove",
          this.handleMouseMove,
          {
            passive: !0,
          }
        ),
        this.productMediaList.addEventListener("keyup", this.handleKeyUp),
        this.initArrows(),
        this.resetScrollPosition(),
        (this.initialized = !0));
    }
    unbindEventListeners() {
      this.initialized &&
        (this.productMediaList.removeEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.removeEventListener(
          "mouseup",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener(
          "touchstart",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "touchend",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "touchmove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
        this.removeArrows(),
        (this.initialized = !1));
    }
    handleMouseDown(t) {
      (this.isDown = !0),
        (this.startX =
          (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
        (this.startY =
          (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
    }
    handleMouseLeave() {
      this.isDown && (this.isDown = !1);
    }
    handleMouseUp(t) {
      const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
        s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
        i = e - this.startX,
        o = s - this.startY,
        n = i > 0 ? 1 : -1;
      Math.abs(i) > 10 &&
        Math.abs(i) > Math.abs(o) &&
        (n < 0 ? this.showNextImage() : this.showPreviousImage()),
        (this.isDown = !1),
        requestAnimationFrame(() => {
          this.classList.remove(Nh);
        });
    }
    handleMouseMove() {
      this.isDown && this.classList.add(Nh);
    }
    handleKeyUp(t) {
      "ArrowLeft" === t.code && this.showPreviousImage(),
        "ArrowRight" === t.code && this.showNextImage();
    }
    handleArrowsClickEvent() {
      var t;
      null === (t = this.querySelectorAll(Hh)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              t.target.hasAttribute(jh) && this.showPreviousImage(),
              t.target.hasAttribute(Xh) && this.showNextImage();
          });
        });
    }
    resetScrollPosition() {
      0 !== this.productMediaList.scrollLeft &&
        (this.productMediaList.scrollLeft = 0);
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(_h),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.productMediaList.append(t),
          (this.buttons = this.querySelectorAll(Hh)),
          (this.buttonPrev = this.querySelector(`[${jh}]`)),
          (this.buttonNext = this.querySelector(`[${Xh}]`));
      }
      this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${_h}`)) || void 0 === t || t.remove();
    }
    preloadImageOnArrowHover() {
      var t, e;
      null === (t = this.buttonPrev) ||
        void 0 === t ||
        t.addEventListener("mouseover", () => {
          const t = this.getPreviousMediaId();
          this.preloadImage(t);
        }),
        null === (e = this.buttonNext) ||
          void 0 === e ||
          e.addEventListener("mouseover", () => {
            const t = this.getNextMediaId();
            this.preloadImage(t);
          });
    }
    preloadImage(t) {
      var e;
      null === (e = this.querySelector(`[${Yh}="${t}"] img`)) ||
        void 0 === e ||
        e.setAttribute("loading", "eager");
    }
    showMediaOnVariantSelect(t) {
      const e = t.detail.id;
      this.setActiveMedia(e);
    }
    getCurrentMedia() {
      return this.querySelector(`${Dh}.${Wh}`);
    }
    getNextMediaId() {
      const t = this.getCurrentMedia(),
        e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(Jh))
          ? null == t
            ? void 0
            : t.nextElementSibling
          : this.querySelector(Dh);
      return null == e ? void 0 : e.getAttribute(Yh);
    }
    getPreviousMediaId() {
      const t = this.getCurrentMedia(),
        e = this.productMediaItems.length - 1,
        s =
          (null == t ? void 0 : t.previousElementSibling) ||
          this.productMediaItems[e];
      return null == s ? void 0 : s.getAttribute(Yh);
    }
    showNextImage() {
      const t = this.getNextMediaId();
      this.selectMedia(t);
    }
    showPreviousImage() {
      const t = this.getPreviousMediaId();
      this.selectMedia(t);
    }
    selectMedia(t) {
      this.dispatchEvent(
        new CustomEvent("theme:media:select", {
          detail: {
            id: t,
          },
        })
      );
    }
    setActiveMedia(t) {
      if (!t) return;
      this.setAttribute(Vh, t);
      const e = this.querySelector(`${Dh}.${Wh}`),
        s = this.querySelector(`[${Yh}="${t}"]`),
        i = null == s ? void 0 : s.querySelector(Bh),
        o = s.querySelector("deferred-media");
      var n;
      (null == e || e.classList.add(Uh),
      null == e || e.classList.remove(Wh),
      null == s || s.classList.remove(Uh, zh),
      null == s || s.classList.add(Wh),
      o && !0 !== o.getAttribute("loaded")) &&
        (null === (n = s.querySelector(Oh)) ||
          void 0 === n ||
          n.dispatchEvent(
            new Event("click", {
              bubbles: !1,
            })
          ));
      requestAnimationFrame(() => {
        this.setHeight(),
          document.body.classList.contains(Rh) && (null == i || i.focus());
      });
    }
    setHeight() {
      var t, e;
      const s =
        (null === (t = this.querySelector(`${Dh}.${Wh}`)) || void 0 === t
          ? void 0
          : t.offsetHeight) ||
        (null === (e = this.productMediaItems[0]) || void 0 === e
          ? void 0
          : e.offsetHeight);
      this.style.setProperty("--height", `${s}px`);
    }
    productMediaObserver() {
      this.productMediaItems.forEach((t) => {
        t.addEventListener("transitionend", (e) => {
          e.target == t &&
            t.classList.contains(Uh) &&
            (t.classList.remove(Uh), t.classList.add(zh));
        }),
          t.addEventListener("transitioncancel", (e) => {
            e.target == t &&
              t.classList.contains(Uh) &&
              (t.classList.remove(Uh), t.classList.add(zh));
          });
      });
    }
    constructor() {
      super(),
        (this.initialized = !1),
        (this.buttons = !1),
        (this.isDown = !1),
        (this.startX = 0),
        (this.startY = 0),
        (this.scrollLeft = 0),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.container = this.closest($h)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleKeyUp = this.handleKeyUp.bind(this)),
        (this.productMediaItems = this.querySelectorAll(Dh)),
        (this.productMediaList = this.querySelector(Fh)),
        (this.setHeight = this.setHeight.bind(this)),
        (this.toggleEvents = this.toggleEvents.bind(this)),
        (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
    }
  };
  const Zh = "data-option-position",
    td = '[name^="options"], [data-popout-option]',
    ed = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    sd = "data-value",
    id = "[data-popout]",
    od = "sold-out",
    nd = "unavailable",
    rd = "sale";
  const ad = "[data-product]",
    ld = "[data-product-form]",
    cd = "product-notification",
    hd = "[data-variant-title]",
    dd = "[data-notification-product]",
    ud = "[data-add-to-cart]",
    pd = "[data-add-to-cart-text]",
    md = "cart-drawer",
    vd = "[data-cart-page]",
    gd = "[data-compare-price]",
    fd = "[data-compare-text]",
    yd = "[data-form-wrapper]",
    bd = "[data-product-select]",
    wd = "[data-price-wrapper]",
    Ed = "product-images",
    Sd = "[data-product-media-list]",
    Ld = "[data-product-json]",
    kd = "[data-product-price]",
    Ad = "[data-product-unit-price]",
    Cd = "[data-product-base]",
    Td = "[data-product-unit]",
    qd = "[data-product-preorder]",
    xd = "[data-subscription-watch-price]",
    Md = "[data-subscription-selectors]",
    Pd = "[data-toggles-group]",
    Id = "data-group-toggle",
    Hd = "[data-plan-description]",
    Od = "[data-section-type]",
    Bd = "[data-variant-sku]",
    Dd = "[data-variant-final-sale-metafield]",
    Fd = "[data-variant-buttons]",
    $d = "[data-variant-option-image]",
    _d = "[data-quick-add-modal]",
    Nd = "[data-price-off]",
    Rd = "[data-price-off-type]",
    Wd = "[data-price-off-amount]",
    zd = "[data-remaining-count]",
    Ud = "[data-remaining-max]",
    Vd = "[data-remaining-wrapper]",
    jd = "[data-product-remaining-json]",
    Xd = "[data-option-value]",
    Jd = "[data-option-position]",
    Yd = "[data-product-form-installment]",
    Qd = 'input[name="id"]',
    Gd = "hidden",
    Kd = "variant--soldout",
    Zd = "variant--unavailable",
    tu = "product__price--sale",
    eu = "count-is-low",
    su = "count-is-in",
    iu = "count-is-out",
    ou = "count-is-unavailable",
    nu = "data-remaining-max",
    ru = "data-enable-history-state",
    au = "data-fader-desktop",
    lu = "data-fader-mobile",
    cu = "data-option-position",
    hu = "data-image-id",
    du = "data-media-id",
    uu = "data-quick-add-btn",
    pu = "data-final-sale",
    mu = "data-variant-image-scroll";
  let vu = class extends HTMLElement {
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(Od) || this.closest(_d)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(ad)),
        (this.productForm = this.container.querySelector(ld)),
        (this.productNotification = this.container.querySelector(cd)),
        (this.productImages = this.container.querySelector(Ed)),
        (this.productMediaList = this.container.querySelector(Sd)),
        (this.installmentForm = this.container.querySelector(Yd)),
        (this.skuWrapper = this.container.querySelector(Bd)),
        (this.sellout = null),
        (this.variantImageScroll = "true" === this.container.getAttribute(mu)),
        (this.priceOffWrap = this.container.querySelector(Nd)),
        (this.priceOffAmount = this.container.querySelector(Wd)),
        (this.priceOffType = this.container.querySelector(Rd)),
        (this.planDescription = this.container.querySelector(Hd)),
        (this.remainingWrapper = this.container.querySelector(Vd)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(Ud);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(nu), 10)),
          (this.remainingCount = this.container.querySelector(zd)),
          (this.remainingJSONWrapper = this.container.querySelector(jd)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(ru)),
        (this.hasUnitPricing = this.container.querySelector(Td)),
        (this.subSelectors = this.container.querySelector(Md)),
        (this.subPrices = this.container.querySelector(xd)),
        (this.isPreOrder = this.container.querySelector(qd));
      let t = null;
      const e = this.container.querySelector(Ld);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new (class {
              init() {
                this.update();
              }
              update() {
                this.getCurrentState(),
                  this.optionElements.forEach((t) => {
                    const e = t.closest(`[${Zh}]`);
                    if (!e) return;
                    const s = t.value || t.getAttribute(sd),
                      i = e.getAttribute(Zh),
                      o = parseInt(i, 10) - 1,
                      n = t.closest(id);
                    let r = [...this.selections];
                    r[o] = s;
                    const a = this.productJSON.variants.find((t) => {
                      let e = !0;
                      for (let s = 0; s < r.length; s++)
                        t.options[s] !== r[s] && (e = !1);
                      return e;
                    });
                    t.classList.remove(od, nd),
                      t.parentNode.classList.remove(rd),
                      n && n.classList.remove(od, nd, rd),
                      void 0 === a
                        ? (t.classList.add(nd), n && n.classList.add(nd))
                        : a &&
                          !1 === a.available &&
                          (t.classList.add(od), n && n.classList.add(od)),
                      a &&
                        a.compare_at_price > a.price &&
                        theme.settings.variantOnSale &&
                        t.parentNode.classList.add(rd);
                  });
              }
              getCurrentState() {
                this.selections = [];
                const t = this.container.querySelectorAll(ed);
                t.length &&
                  t.forEach((t) => {
                    const e = t.value;
                    e && "" !== e && this.selections.push(e);
                  });
              }
              constructor(t, e) {
                (this.container = t),
                  (this.productJSON = e),
                  (this.optionElements = this.container.querySelectorAll(td)),
                  this.productJSON && this.optionElements.length && this.init();
              }
            })(this.container, this.productJSON)))
          : console.error("Missing product JSON"),
        (this.variantOptionImages = this.container.querySelectorAll($d)),
        (this.variantButtons = this.container.querySelectorAll(Fd)),
        this.variantOptionImages.length > 1 && this.optionImagesWidth();
    }
    cartAddEvents() {
      this.buttonATC = this.querySelector(ud);
      const t = document.querySelector(md) || document.querySelector(vd);
      this.buttonATC &&
        t &&
        this.buttonATC.addEventListener("click", (t) => {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                detail: {
                  button: this.buttonATC,
                },
                bubbles: !1,
              })
            ),
            this.closest(_d) ||
              (window.accessibility.lastElement = this.buttonATC);
        });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new (class {
        destroy() {
          this._listeners.removeAll();
        }
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        }
        variant() {
          const t = this.options();
          return t.length ? Tl(this.product, t) : this.product.variants[0];
        }
        plan(t) {
          let e = {
            allocation: null,
            group: null,
            detail: null,
          };
          const s = this.element.querySelector(`${Ml}:checked`);
          if (!s) return null;
          const i = s.value,
            o = i && "" !== i ? i : null;
          return (
            o &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === o.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === o.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        }
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        }
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        }
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        }
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        }
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        }
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        }
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        }
        _serializeInputValues(t, e) {
          return t.reduce(function (t, s) {
            return (
              (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
                t.push(
                  e({
                    name: s.name,
                    value: s.value,
                  })
                ),
              t
            );
          }, []);
        }
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        }
        constructor(t, e, s) {
          (this.element = t),
            (this.product = this._validateProductObject(e)),
            (this.variantElement = this.element.querySelector(xl)),
            (s = s || {}),
            (this._listeners = new Cl()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, s)
            ),
            (this.optionInputs = this._initInputs(Pl, s.onOptionChange)),
            (this.planInputs = this._initInputs(Ml, s.onPlanChange)),
            (this.quantityInputs = this._initInputs(Il, s.onQuantityChange)),
            (this.propertyInputs = this._initInputs(Hl, s.onPropertyChange));
        }
      })(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      var s;
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateNotificationForm(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSku(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        null === (s = this.sellout) || void 0 === s || s.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(wd),
        o = this.container.querySelectorAll(ud),
        n = this.container.querySelectorAll(pd),
        r = this.container.querySelectorAll(yd);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(Qd);
        (t.value = e.id),
          t.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(Gd);
          }),
        null == o ||
          o.forEach((t) => {
            t.hasAttribute(uu) ||
              (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
          }),
        null == n ||
          n.forEach((t) => {
            let i = s;
            e
              ? e.available || (i = theme.strings.soldOut)
              : (i = theme.strings.unavailable),
              (t.textContent = i);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(Kd, Zd)
                : (t.classList.add(Kd), t.classList.remove(Zd));
              const s = t.querySelector(bd);
              s && (s.value = e.id);
              const i = t.querySelector(`${Qd}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add(Zd), t.classList.remove(Kd);
          });
    }
    updateNotificationForm(t) {
      if (!this.productNotification) return;
      const e = this.productNotification.querySelector(hd),
        s = this.productNotification.querySelector(dd);
      null != e &&
        ((e.textContent = t.variant.title), (s.value = t.variant.name));
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState(
          {
            path: n,
          },
          "",
          n
        );
      }
    }
    updateRemaining(t) {
      var e;
      const s = t.variant;
      if (
        (null === (e = this.remainingWrapper) ||
          void 0 === e ||
          e.classList.remove(su, iu, ou, eu),
        s && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[s.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(iu),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(su),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(eu),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !s && this.remainingWrapper && this.remainingWrapper.classList.add(ou);
    }
    optionImagesWidth() {
      var t;
      if (!this.variantButtons) return;
      let e = 0;
      for (const t of this.variantOptionImages) {
        const s = t.offsetWidth;
        s > e && (e = s);
      }
      null === (t = this.variantButtons.style) ||
        void 0 === t ||
        t.setProperty("--option-image-width", e + "px");
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(Pd).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${Id}="${e}"]`),
              i = this.container.querySelectorAll(`[${Id}]`);
            if (s) {
              s.classList.remove(Gd);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(Gd);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(Gd);
    }
    isVariantFinalSale(t) {
      const e = document.querySelector(Dd).textContent,
        s = JSON.parse(e);
      let i = !1;
      return (
        s.forEach((e) => {
          Number(e.variant_id) === t.id && (i = "true" === e.metafield_value);
        }),
        i
      );
    }
    updateSaleTextStandard(t) {
      const e = t.variant;
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = (e.compare_at_price - e.price) / e.compare_at_price,
          s = Math.floor(100 * t);
        (this.priceOffAmount.innerHTML = `${s}%`),
          this.priceOffWrap.classList.remove(Gd);
      }
      this.closest(_d) ||
        (this.priceOffWrap.hasAttribute(pu) || this.isVariantFinalSale(e)
          ? this.priceOffWrap.classList.remove(Gd)
          : this.priceOffWrap.classList.add(Gd));
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(Gd))
        : this.planDescription && this.planDescription.classList.add(Gd);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          s = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${s}%`)
          : (this.priceOffAmount.innerHTML = Re(s, theme.moneyFormat)),
          this.priceOffWrap.classList.remove(Gd);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        s = t.plan;
      this.container.querySelectorAll(wd).forEach((t) => {
        const i = t.querySelector(gd),
          o = t.querySelector(kd),
          n = t.querySelector(fd);
        let r = "",
          a = "";
        this.productState.available &&
          ((r = e.compare_at_price), (a = e.price)),
          this.productState.hasPlan && (a = s.allocation.price),
          this.productState.planSale &&
            ((r = s.allocation.compare_at_price), (a = s.allocation.price)),
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(Gd),
                n.classList.remove(Gd),
                o.classList.add(tu))
              : (i.classList.add(Gd),
                n.classList.add(Gd),
                o.classList.remove(tu)),
            (i.innerHTML = Re(r, theme.moneyFormat))),
          (o.innerHTML =
            0 === a ? window.theme.strings.free : Re(a, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        s = t.plan;
      let i = null;
      if (
        (e && e.unit_price && (i = e.unit_price),
        s &&
          s.allocation &&
          s.allocation.unit_price &&
          (i = s.allocation.unit_price),
        i)
      ) {
        const t = this.getBaseUnit(e),
          s = Re(i, theme.moneyFormat);
        (this.container.querySelector(Ad).innerHTML = s),
          (this.container.querySelector(Cd).innerHTML = t),
          Fe(this.container.querySelector(Td));
      } else
        (o = this.container.querySelector(Td)) && (o.style.display = "none");
      var o;
    }
    updateSku(t) {
      this.skuWrapper &&
        (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: {
            variant: e,
          },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `[${hu}="${e.featured_media.id}"]`
        );
        if (t) {
          const e = t.getAttribute(du),
            s = f();
          if (
            (t.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: {
                  id: e,
                },
              })
            ),
            s &&
              !this.productImages.hasAttribute(au) &&
              this.variantImageScroll)
          ) {
            const e = t.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: {
                  hideTransition: !1,
                },
              })
            ),
              In(e);
          }
          s ||
            this.productImages.hasAttribute(lu) ||
            this.productMediaList.scrollTo({
              left: t.offsetLeft,
            });
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(Xd);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(Jd);
            if (s) {
              const i = s.getAttribute(cu),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
    constructor() {
      super();
    }
  };
  const gu = "[data-image-id]",
    fu = "product-images",
    yu = "[data-section-type]",
    bu = "[data-thumb-item]",
    wu = "[data-thumb-link]",
    Eu = "[data-thumbs-slider]",
    Su = "data-active-media",
    Lu = "data-media-id",
    ku = "is-active";
  class Au extends HTMLElement {
    connectedCallback() {
      this.handleEvents(),
        this.preloadImagesOnHover(),
        this.activeMediaObserver();
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }
    activeMediaObserver() {
      (this.observer = new MutationObserver((t) => {
        for (const e of t)
          "attributes" === e.type &&
            e.attributeName == Su &&
            this.setActiveThumb();
      })),
        this.observer.observe(this.productImagesContainer, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
    }
    handleEvents() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault();
          const s = t.closest(bu),
            i = t.getAttribute(Lu);
          s.classList.contains(ku) ||
            this.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: {
                  id: i,
                },
              })
            );
        }),
          t.addEventListener("keyup", (e) => {
            if ("Enter" === e.code) {
              var s;
              const e = t.getAttribute(Lu),
                i =
                  null ===
                    (s = this.productImagesContainer.querySelector(
                      `[${Lu}="${e}"]`
                    )) || void 0 === s
                    ? void 0
                    : s.querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
              i &&
                (i.dispatchEvent(new Event("focus")),
                i.dispatchEvent(new Event("select")));
            }
          });
      });
    }
    preloadImagesOnHover() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("mouseover", () => {
          const e = t.getAttribute(Lu),
            s = this.productImagesContainer.querySelector(`[${Lu}="${e}"] img`);
          null == s || s.setAttribute("loading", "eager");
        });
      });
    }
    setActiveThumb() {
      var t;
      const e = this.productImagesContainer.getAttribute(Su),
        s = this.querySelector(`[${Lu}="${e}"]`);
      null === (t = this.querySelector(`${bu}.${ku}`)) ||
        void 0 === t ||
        t.classList.remove(ku),
        null == s || s.parentNode.classList.add(ku),
        requestAnimationFrame(() => {
          this.scrollToThumb();
        });
    }
    scrollToThumb() {
      const t = this.thumbSlider;
      if (t) {
        const e = t.querySelector(`.${ku}`);
        if (!e) return;
        const s = t.scrollTop,
          i = t.scrollLeft,
          o = t.offsetWidth,
          n = t.offsetHeight,
          r = s + n,
          a = i + o,
          l = e.offsetTop,
          c = e.offsetLeft,
          h = e.offsetWidth,
          d = e.offsetHeight,
          u = s > l,
          p = i > c,
          m = c + h > a,
          v = l + d > r || u,
          g = m || p,
          f = y();
        if (v || g) {
          let e = l - n + d,
            s = c - o + h;
          u && (e = l),
            m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)),
            p &&
              ((s = c),
              f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))),
            t.scrollTo({
              top: e,
              left: s,
              behavior: "smooth",
            });
        }
      }
    }
    constructor() {
      super(),
        (this.container = this.closest(yu)),
        (this.productImages = this.container.querySelectorAll(gu)),
        (this.productImagesContainer = this.container.querySelector(fu)),
        (this.productThumbs = this.container.querySelectorAll(bu)),
        (this.thumbSlider = this.querySelector(Eu)),
        (this.thumbLinks = this.querySelectorAll(wu));
    }
  }
  const Cu = "[data-popup-open]",
    Tu = "[data-popup-close]",
    qu = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    xu = "closing";
  let Mu = class {
    popupOpen() {
      this.popup &&
        ((this.isAnimating = !0),
        this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal || "function" != typeof this.popup.show
          ? this.popup.setAttribute("open", "")
          : this.popup.show(),
        this.popup.removeAttribute("inert"),
        this.popup.focus(),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
            })
          ),
        li(this.popup).then(() => {
          (this.isAnimating = !1),
            this.enableScrollLock && this.a11y.trapFocus(this.popup);
          const t =
            this.popup.querySelector("[autofocus]") ||
            this.popup.querySelector(qu);
          null == t || t.focus();
        }));
    }
    popupClose() {
      if (
        !this.isAnimating &&
        this.popup &&
        !this.popup.hasAttribute("inert")
      ) {
        if (!this.popup.hasAttribute(xu))
          return (
            this.popup.setAttribute(xu, ""),
            (this.isAnimating = !0),
            void li(this.popup).then(() => {
              (this.isAnimating = !1), this.popupClose();
            })
          );
        "function" == typeof this.popup.close
          ? this.popup.close()
          : this.popup.removeAttribute("open"),
          this.popupCloseActions();
      }
    }
    popupCloseActions() {
      this.popup.hasAttribute("inert") ||
        (this.popup.setAttribute("inert", ""),
        this.popup.removeAttribute(xu),
        !_c() &&
          this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          ),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:onclose", {
            bubbles: !1,
          })
        ),
        this.enableScrollLock &&
          (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
    }
    popupEvents() {
      var t;
      if (!this.popup) return;
      null === (t = this.buttonPopupOpen) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            this.popupOpen(),
            (window.accessibility.lastElement = this.buttonPopupOpen);
        });
      const e = this.popup.querySelectorAll(Tu);
      e.length &&
        e.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("close", () => this.popupCloseActions());
    }
    constructor(t, e, s = !0, i = !0) {
      var o;
      (this.popup = t),
        (this.holder = e),
        (this.a11y = R),
        (this.isAnimating = !1),
        (this.showModal = s),
        (this.enableScrollLock = i),
        (this.buttonPopupOpen =
          null === (o = this.holder) || void 0 === o
            ? void 0
            : o.querySelector(Cu)),
        this.popupEvents();
    }
  };
  const Pu = "dialog";
  let Iu = class extends HTMLElement {
      connectedCallback() {
        new Mu(this.querySelector(Pu), this, !0, !0);
      }
      constructor() {
        super();
      }
    },
    Hu = class extends Xt {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const Ou = "data-store-availability-container",
    Bu = ".shopify-section",
    Du = "[data-pickup-drawer]",
    Fu = "[data-section-type]",
    $u = "hidden";
  let _u = class extends HTMLElement {
    connectedCallback() {
      (this.container = this.closest(Fu)),
        (this.drawer = null),
        this.container.addEventListener("theme:variant:change", (t) =>
          this.fetchPickupAvailability(t)
        ),
        this.fetchPickupAvailability();
    }
    fetchPickupAvailability(t) {
      if (
        (t && !t.detail.variant) ||
        (t && t.detail.variant && !t.detail.variant.available)
      )
        return void this.classList.add($u);
      const e =
        t && t.detail.variant ? t.detail.variant.id : this.getAttribute(Ou);
      e &&
        ((this.popupActions = null),
        fetch(
          `${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`
        )
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser()
              .parseFromString(t, "text/html")
              .querySelector(Bu).innerHTML;
            (this.innerHTML = e),
              (this.drawer = this.querySelector(Du)),
              this.drawer
                ? (this.classList.remove($u),
                  (this.popupActions = new Mu(this.drawer, this, !0, !0)))
                : this.classList.add($u);
          })
          .catch((t) => {
            console.error(t);
          }));
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new ze({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    constructor() {
      super();
    }
  };
  const Nu = {};

  function Ru(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return Nu[t.url]
        ? Nu[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (Nu[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return Nu[t.json]
        ? Promise.resolve(Nu[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((Nu[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return Nu[e]
        ? Nu[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (Nu[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const Wu = ".pswp",
    zu = ".pswp__custom-close",
    Uu = "iframe, video",
    Vu = ".pswp__thumbs",
    ju = "is-current",
    Xu = "pswp--custom-loader",
    Ju = "pswp--custom-opening",
    Yu = "pswp__loader",
    Qu = "is-focused",
    Gu = "data-pswp-option-classes",
    Ku = "aria-current",
    Zu = `<div class="${Yu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  let tp = class {
    init() {
      this.pswpElement.classList.add(Ju),
        this.initLoader(),
        Ru({
          url: window.theme.assets.photoswipe,
        })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(Xu) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(Gu, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = Zu), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(Gu, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(Xu) &&
        this.pswpElement.classList.remove(Xu),
        this.pswpElement.classList.remove(Ju),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.init(),
        this.thumbsActions(),
        document.body.classList.contains(Qu) &&
          setTimeout(() => {
            this.a11y.trapFocus(this.pswpElement, {
              elementToFocus: this.closeBtn,
            });
          }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.children.length &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${Vu} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i = t.parentElement.querySelector(`.${ju}`);
            i.classList.remove(ju),
              i.setAttribute(Ku, !1),
              t.classList.add(ju),
              t.setAttribute(Ku, !0),
              this.popup.goTo(e);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    keyupClose(t) {
      "Enter" === t.code && this.popup.close();
    }
    onClose() {
      const t = this.pswpElement.querySelector(Uu);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(Gu, "");
      const e = this.pswpElement.querySelector(`.${Yu}`);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement();
    }
    setCurrentThumb() {
      const t = this.pswpElement.querySelector(`${Vu} > .${ju}`);
      if (
        (t && (t.classList.remove(ju), t.setAttribute(Ku, !1)),
        !this.popupThumbs)
      )
        return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(ju), e.setAttribute(Ku, !0), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = t.offsetLeft;
      if (e <= s + t.offsetWidth || e > s) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - e,
          behavior: "smooth",
        });
      }
    }
    constructor(t, e = "") {
      (this.items = t),
        (this.pswpElement = document.querySelectorAll(Wu)[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(Vu)),
        (this.closeBtn = this.pswpElement.querySelector(zu)),
        (this.keyupCloseEvent = (t) => this.keyupClose(t)),
        (this.a11y = R);
      (this.options =
        "" !== e
          ? e
          : {
              history: !1,
              focus: !1,
              mainClass: "",
            }),
        this.init();
    }
  };
  const ep = "[data-zoom-caption]",
    sp = "[data-zoom-image]",
    ip = "[data-pswp-thumbs-template]",
    op = "[data-section-type]",
    np = ".pswp__thumbs",
    rp = "product-images",
    ap = "is-dragging",
    lp = "variant--soldout",
    cp = "variant--unavailable",
    hp = "pswp-zoom-gallery",
    dp = "pswp-zoom-gallery--single",
    up = "data-image-src",
    pp = "data-image-width",
    mp = "data-image-height";
  let vp = class extends HTMLElement {
    connectedCallback() {
      this.images.forEach((t, e) => {
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.closest(rp).classList.contains(ap) ||
              (this.createZoom(e), (window.accessibility.lastElement = t));
        }),
          t.addEventListener("keyup", (s) => {
            "Enter" === s.code &&
              (s.preventDefault(),
              this.createZoom(e),
              (window.accessibility.lastElement = t));
          });
      });
    }
    createZoom(t) {
      const e = this.container.querySelector(ip),
        s = null == e ? void 0 : e.innerHTML;
      let i = [],
        o = 0;
      this.images.forEach((e) => {
        const n = e.getAttribute(up);
        if (
          ((o += 1),
          i.push({
            src: n,
            w: parseInt(e.getAttribute(pp)),
            h: parseInt(e.getAttribute(mp)),
            msrc: n,
          }),
          this.images.length === o)
        ) {
          new tp(i, {
            history: !1,
            focus: !1,
            index: t,
            mainClass: 1 === o ? `${hp} ${dp}` : `${hp}`,
            showHideOpacity: !0,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !0,
            closeEl: !0,
            closeElClasses: ["caption-close", "title"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
            addCaptionHTMLFn: (t, e, s) => {
              this.zoomCaption(t, e, s);
            },
            getThumbBoundsFn: () => {
              const e = this.images[t],
                s = window.scrollY || document.documentElement.scrollTop,
                i = e.getBoundingClientRect();
              return {
                x: i.left,
                y: i.top + s,
                w: i.width,
              };
            },
          }),
            this.thumbsContainer &&
              "" !== s &&
              (this.thumbsContainer.innerHTML = s);
        }
      });
    }
    zoomCaption(t, e) {
      let s = "";
      const i = e.children[0];
      return (
        this.zoomCaptions &&
          ((s = this.zoomCaptions.innerHTML),
          this.zoomCaptions.closest(`.${lp}`)
            ? i.classList.add(lp)
            : i.classList.remove(lp),
          this.zoomCaptions.closest(`.${cp}`)
            ? i.classList.add(cp)
            : i.classList.remove(cp)),
        (i.innerHTML = s),
        !1
      );
    }
    constructor() {
      super(),
        (this.container = this.closest(op)),
        (this.images = this.querySelectorAll(sp)),
        (this.zoomCaptions = this.container.querySelector(ep)),
        (this.thumbsContainer = document.querySelector(np));
    }
  };
  const gp = "[data-add-to-cart]",
    fp = "[data-product-json]",
    yp = "[data-product-form]",
    bp = "#cart-bar",
    wp = "[data-popup-open]",
    Ep = ".product__submit__add",
    Sp = "[data-form-wrapper]",
    Lp = "[data-product-variants]",
    kp = "[data-slider]",
    Ap = "is-visible",
    Cp = "is-loading",
    Tp = "data-cart-bar-enabled",
    qp = "data-add-to-cart-bar",
    xp = "data-cart-bar-scroll",
    Mp = "data-cart-bar-product-notification",
    Pp = "data-section-id",
    Ip = "data-slider-index",
    Hp = {};
  const Op = {
    onLoad() {
      Hp[this.id] = new (class {
        initCartBar() {
          (this.cartBarBtns = this.cartBar.querySelectorAll(Ep)),
            this.cartBarBtns.length > 0 &&
              this.cartBarBtns.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(),
                    t.currentTarget.hasAttribute(qp)
                      ? (this.cartBarEnabled &&
                          (t.currentTarget.classList.add(Cp),
                          t.currentTarget.setAttribute("disabled", "disabled")),
                        this.form.querySelector(gp).dispatchEvent(
                          new Event("click", {
                            bubbles: !0,
                          })
                        ))
                      : t.currentTarget.hasAttribute(xp)
                      ? this.scrollToTop()
                      : t.currentTarget.hasAttribute(Mp) &&
                        this.container
                          .querySelector(wp)
                          .dispatchEvent(new Event("click"));
                }),
                  t.hasAttribute(qp) &&
                    document.addEventListener(
                      "theme:product:add-error",
                      this.scrollToTop
                    );
              }),
            this.setCartBarHeight();
        }
        scrollToTop() {
          const t = this.container.querySelector(Lp),
            e = (f() ? this.container : t || this.form).getBoundingClientRect()
              .top;
          In(f() ? e : e - 10);
        }
        toggleCartBarOnScroll() {
          const t = window.scrollY,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const s = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(Ap, s);
          }
        }
        setCartBarHeight() {
          const t = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            "--cart-bar-height",
            `${t}px`
          );
        }
        onUnload() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.cartBarEnabled &&
              (document.removeEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.removeEventListener(
                "theme:resize",
                this.setCartBarHeight
              ));
        }
        onBlockSelect(t) {
          const e = t.srcElement.closest(kp);
          if (e && this.slider.length) {
            const s = e.hasAttribute(Ip) ? e.getAttribute(Ip) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockSelect(t);
          }
        }
        onBlockDeselect(t) {
          const e = t.srcElement.closest(kp);
          if (e && this.slider.length) {
            const s = e.hasAttribute(Ip) ? e.getAttribute(Ip) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockDeselect(t);
          }
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.id = this.container.getAttribute(Pp)),
            (this.sliders = this.container.querySelectorAll(kp)),
            (this.slider = []),
            (this.formWrapper = this.container.querySelector(Sp)),
            (this.cartBarEnabled = this.container.hasAttribute(Tp)),
            (this.cartBar = this.container.querySelector(bp)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.toggleCartBarOnScroll =
              this.toggleCartBarOnScroll.bind(this)),
            (this.unlockTimer = 0),
            (this.accessibility = R);
          const e = this.container.querySelector(fp);
          if ((e && !e.innerHTML) || !e) return;
          const s = JSON.parse(e.innerHTML).handle;
          let i = {};
          s &&
            (i = {
              handle: s,
            }),
            Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.container.querySelector(yp)),
            this.sliders.length &&
              this.sliders.forEach((t, e) => {
                t.setAttribute(Ip, e),
                  this.slider.push(new Mn(this.container, t));
              }),
            this.cartBarEnabled &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              document.addEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.addEventListener("theme:resize", this.setCartBarHeight));
        }
      })(this);
    },
    onUnload(t) {
      Hp[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      Hp[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      Hp[this.id].onBlockDeselect(t);
    },
  };
  Uo("product", [Op, on, $c, Th]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", mh),
    customElements.get("pickup-availability") ||
      customElements.define("pickup-availability", _u),
    customElements.get("product-form") ||
      customElements.define("product-form", vu),
    customElements.get("product-images") ||
      customElements.define("product-images", Kh),
    customElements.get("product-thumbs") ||
      customElements.define("product-thumbs", Au),
    customElements.get("product-modal") ||
      customElements.define("product-modal", Iu),
    customElements.get("product-model") ||
      customElements.define("product-model", Hu),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", bc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ac),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", bh),
    customElements.get("share-button") ||
      customElements.define("share-button", Ih),
    customElements.get("zoom-images") ||
      customElements.define("zoom-images", vp);
  const Bp = "[data-api-related-template]",
    Dp = "[data-related-section]",
    Fp = "[data-grid-item]",
    $p = "[data-recent-wrapper]",
    _p = "[data-recently-viewed-wrapper]",
    Np = ".product-item",
    Rp = "grid-slider",
    Wp = "data-limit",
    zp = "data-minimum",
    Up = "data-product-id",
    Vp = "is-hidden",
    jp = "grid--mobile-slider",
    Xp = {};
  const Jp = {
    onLoad() {
      Xp[this.id] = new (class {
        related() {
          const t = this.container.querySelector(Dp);
          if (!t) return;
          const e = t.getAttribute(Up),
            s = t.getAttribute(Wp),
            i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
          fetch(i)
            .then((t) => t.text())
            .then((e) => {
              const s = document.createElement("div");
              (s.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(Bp).innerHTML),
                s.querySelector(Fp)
                  ? ((t.innerHTML = s.innerHTML),
                    0 ===
                      parseInt(t.style.getPropertyValue("--COLUMNS-MOBILE")) &&
                      t.querySelector(Fp).parentElement.classList.add(jp))
                  : t.dispatchEvent(
                      new CustomEvent("theme:tab:hide", {
                        bubbles: !0,
                      })
                    );
            })
            .catch(function () {
              t.dispatchEvent(
                new CustomEvent("theme:tab:hide", {
                  bubbles: !0,
                })
              );
            });
        }
        recent() {
          const t = this.container.querySelector($p),
            e = t ? parseInt(t.getAttribute(Wp)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            target: "api-product-grid-item",
            onComplete: (t, e) => {
              const s = e.container;
              if (!s) return;
              const i = s.querySelector($p),
                o = s.querySelector(_p),
                n = t.querySelectorAll(Np),
                r = i.querySelector(Rp),
                a = i.hasAttribute(zp) ? parseInt(i.getAttribute(zp)) : 4,
                l = !o && n.length > 0,
                c = o && n.length >= a;
              (l || c) &&
                (c && o.classList.remove(Vp),
                i.classList.remove("is-hidden"),
                i.dispatchEvent(
                  new CustomEvent("theme:tab:check", {
                    bubbles: !0,
                  })
                ),
                r &&
                  r.dispatchEvent(
                    new CustomEvent("theme:grid-slider:init", {
                      bubbles: !0,
                    })
                  ));
            },
          });
        }
        constructor(t) {
          (this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent();
        }
      })(this);
    },
  };
  Uo("related", [Jp, $c]), Uo("reviews", [Pn, vl]);
  const Yp = {},
    Qp = "[data-slider-logos]",
    Gp = "[data-slider-text]",
    Kp = "[data-slide]",
    Zp = "is-selected",
    tm = "is-initialized",
    em = "flickity-enabled",
    sm = "data-slide",
    im = "data-slide-index";
  Uo("logos", [
    {
      onLoad() {
        Yp[this.id] = new (class {
          getSlidesWidth() {
            return 200 * this.logoSlides.length;
          }
          initSlideshowText() {
            this.slideshowText &&
              (this.flkty = new o(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: !1,
                accessibility: !1,
                on: {
                  ready: () => this.sliderAccessibility(),
                  change: () => this.sliderAccessibility(),
                },
              }));
          }
          sliderAccessibility() {
            const t = this.slideshowText.querySelectorAll(
              `${Kp} a, ${Kp} button`
            );
            t.length &&
              t.forEach((t) => {
                const e = t.closest(Kp);
                if (e) {
                  const s = e.classList.contains(Zp) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              (this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", () => {
                    const e = parseInt(t.getAttribute(im)),
                      s = this.slideshowNav.classList.contains(em);
                    if ((this.flkty && this.flkty.select(e), s))
                      this.flktyNav.select(e),
                        this.slideshowNav.classList.contains(Zp) ||
                          this.flktyNav.playPlayer();
                    else {
                      const e = this.slideshowNav.querySelector(`.${Zp}`);
                      e && e.classList.remove(Zp), t.classList.add(Zp);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            const t = this.slideshowNav.classList.contains(em);
            if (this.logoSlidesWidth > v()) {
              if (!t) {
                this.slideshowNav.classList.add(tm);
                const t = this.slideshowNav.querySelector(`.${Zp}`);
                t && t.classList.remove(Zp),
                  this.logoSlides[0].classList.add(Zp),
                  this.flktyNav ||
                    ((this.flktyNav = new i(this.slideshowNav, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      contain: !1,
                      pageDots: !1,
                      wrapAround: !0,
                      watchCSS: !0,
                      selectedAttraction: 0.05,
                      friction: 0.8,
                      initialIndex: 0,
                    })),
                    this.flktyNav.on("deactivate", () => {
                      this.slideshowNav.querySelector(Kp).classList.add(Zp),
                        this.flkty && this.flkty.select(0);
                    }),
                    this.flkty &&
                      (this.flkty.select(0),
                      this.flktyNav.on("change", (t) => this.flkty.select(t))));
              }
            } else t && this.slideshowNav.classList.remove(tm);
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            const e = this.slideshowNav.querySelector(
                `[${sm}="${t.detail.blockId}"]`
              ),
              s = parseInt(e.getAttribute(im));
            this.slideshowNav.classList.contains(em)
              ? (this.flktyNav.select(s),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(Zp))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(em) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(Zp));
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize",
              this.setSlideshowNavStateOnResize
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(Qp)),
              (this.slideshowText = this.container.querySelector(Gp)),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              (this.logoSlides = this.slideshowNav.querySelectorAll(Kp)),
              (this.logoSlidesWidth = this.getSlidesWidth()),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        Yp[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Yp[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Yp[this.id].onBlockDeselect(t);
      },
    },
    vl,
  ]);
  const om = "data-video-play";
  let nm = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.videoPlay = this.querySelectorAll(`[${om}]`)),
        null === (t = this.videoPlay) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("click", (t) => {
              const e = t.currentTarget;
              if ("" !== e.getAttribute(om).trim()) {
                t.preventDefault();
                const s = [
                  {
                    html: e.getAttribute(om),
                  },
                ];
                new tp(s, {
                  mainClass: "pswp--video",
                }),
                  (window.accessibility.lastElement = e);
              }
            });
          });
    }
    constructor() {
      super();
    }
  };
  const rm = "[data-video-template]",
    am = "is-loading",
    lm = "data-video-id";
  let cm = class extends HTMLElement {
    connectedCallback() {
      (this.videoId = this.getAttribute(lm)),
        (this.videoTemplate = this.querySelector(rm)),
        (this.video = null),
        (this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this)),
        this.videoId && this.renderVideo();
    }
    powerSaverVideoPlay() {
      var t;
      null === (t = this.video) || void 0 === t || t.play();
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(am),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                this.video
                  .play()
                  .then(() => {})
                  .catch(() => {
                    document.addEventListener(
                      "click",
                      this.powerSaverVideoPlay,
                      {
                        passive: !0,
                        bubbles: !0,
                        once: !0,
                      }
                    ),
                      document.addEventListener(
                        "touchstart",
                        this.powerSaverVideoPlay,
                        {
                          passive: !0,
                          bubbles: !0,
                          once: !0,
                        }
                      );
                  }),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            e && "function" == typeof this.video.play && this.video.play(),
              e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        {
          rootMargin: "0px",
          threshold: [0, 1],
        }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect(),
        this.videoId &&
          (document.removeEventListener("click", this.powerSaverVideoPlay),
          document.removeEventListener("touchstart", this.powerSaverVideoPlay));
    }
    constructor() {
      super();
    }
  };
  Uo("featured-video", [rn]),
    customElements.get("video-background") ||
      customElements.define("video-background", cm),
    customElements.get("video-popup") ||
      customElements.define("video-popup", nm),
    Uo("slideshow", [Pn, rn]);
  const hm = "[data-image-holder]",
    dm = "[data-image-element]",
    um = "[data-range-button]",
    pm = "[data-range-input]";
  let mm = class extends HTMLElement {
    connectedCallback() {
      this.setOverlapImageSize(),
        this.setImagePosition(),
        this.rangeInput.addEventListener("input", () =>
          this.setImagePosition()
        ),
        document.addEventListener("theme:resize", this.setOverlapImageSize);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.setOverlapImageSize);
    }
    setImagePosition() {
      const t = this.rangeInput.value,
        e = this.imageElement.offsetWidth,
        s = this.rangeButton.offsetWidth;
      (this.rangeButton.style.left = `${t}%`),
        (this.imageHolder.style.width =
          ((e - s) * (100 - t)) / 100 + s / 2 + "px");
    }
    setOverlapImageSize() {
      const t = this.offsetWidth;
      (this.imageElement.style.width = `${t}px`), this.setImagePosition();
    }
    constructor() {
      super(),
        (this.imageHolder = this.querySelector(hm)),
        (this.imageElement = this.querySelector(dm)),
        (this.rangeButton = this.querySelector(um)),
        (this.rangeInput = this.querySelector(pm)),
        (this.setOverlapImageSize = this.setOverlapImageSize.bind(this));
    }
  };
  Uo("custom-content", [Pn, rn, Wn]),
    customElements.get("video-background") ||
      customElements.define("video-background", cm),
    customElements.get("video-popup") ||
      customElements.define("video-popup", nm),
    customElements.get("compare-images") ||
      customElements.define("compare-images", mm);
  var vm = {};

  function gm(t) {
    return vm[t];
  }
  (vm.basic = []),
    (vm.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            lightness: "64",
          },
          {
            hue: "#ff0000",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f0f0f0",
          },
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            saturation: "-41",
          },
          {
            color: "#e8ede7",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: "-100",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            lightness: "25",
          },
          {
            gamma: "1.06",
          },
          {
            saturation: "-100",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            gamma: "10.00",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            gamma: "10.00",
          },
          {
            lightness: "100",
          },
          {
            weight: "0.4",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            weight: "0.01",
          },
          {
            lightness: "39",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.50",
          },
          {
            gamma: "10.00",
          },
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#cfe5ee",
          },
          {
            visibility: "on",
          },
        ],
      },
    ]),
    (vm.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            gamma: "3.86",
          },
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#cccccc",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f2f2f2",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#e4e4e4",
          },
          {
            visibility: "on",
          },
        ],
      },
    ]),
    (vm.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
          {
            saturation: 36,
          },
          {
            color: "#000000",
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#000000",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            lightness: "-82",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [
          {
            invert_lightness: !0,
          },
          {
            weight: "7.15",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 29,
          },
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
        ],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let fm = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  Uo("map", {
    onLoad() {
      fm[this.id] = new (class {
        initMaps() {
          (function (t) {
            if (null === window.theme.mapAPI) {
              const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
              window.theme.mapAPI = Ru({
                url: e,
              });
            }
            return window.theme.mapAPI;
          })(this.key)
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new google.maps.LatLng(this.lat, this.long)
                : ((t = this.address),
                  new Promise((e, s) => {
                    new google.maps.Geocoder().geocode(
                      {
                        address: t,
                      },
                      function (t, i) {
                        if ("OK" == i) {
                          var o = {
                            lat: t[0].geometry.location.lat(),
                            lng: t[0].geometry.location.lng(),
                          };
                          e(o);
                        } else s(i);
                      }
                    );
                  }));
              var t;
            })
            .then((t) => {
              const e = {
                  zoom: parseInt(this.zoomString, 10),
                  styles: gm(this.styleString),
                  center: t,
                  draggable: !0,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  zoomControl: !1,
                  disableDefaultUI: !0,
                },
                s = (function (t, e) {
                  var s = new google.maps.Map(t, e),
                    i = s.getCenter();
                  return (
                    new google.maps.Marker({
                      map: s,
                      position: i,
                    }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(s, "resize"), s.setCenter(i);
                      }
                    ),
                    s
                  );
                })(this.mapContainer, e);
              return s;
            })
            .then((t) => {
              (this.map = t), (fm[this.id] = t);
            })
            .catch((t) => {
              console.log("Failed to load Google Map"), console.log(t);
            });
        }
        unload() {
          void 0 !== window.google &&
            google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(t) {
          (this.container = t.container),
            (this.mapContainer = this.container.querySelector(
              "[data-map-container]"
            )),
            (this.key = this.container.getAttribute("data-api-key")),
            (this.styleString =
              this.container.getAttribute("data-style") || ""),
            (this.zoomString = this.container.getAttribute("data-zoom") || 14),
            (this.address = this.container.getAttribute("data-address")),
            (this.enableCorrection = this.container.getAttribute(
              "data-latlong-correction"
            )),
            (this.lat = this.container.getAttribute("data-lat")),
            (this.long = this.container.getAttribute("data-long")),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof fm[this.id].unload && fm[this.id].unload();
    },
  });
  const ym = "[data-large-promo]",
    bm = "[data-large-promo-inner]",
    wm = "[data-tracking-consent]",
    Em = "[data-confirm-cookies]",
    Sm = "cart-bar",
    Lm = "[data-newsletter]",
    km = "[data-newsletter-holder]",
    Am = "[data-newsletter-heading]",
    Cm = "[data-newsletter-field]",
    Tm = "[data-promo-text]",
    qm = "[data-newsletter-form]",
    xm = "data-popup-delay",
    Mm = "data-cookie-name",
    Pm = "data-target-referrer",
    Im = "hidden",
    Hm = "has-value",
    Om = "cart-bar-visible",
    Bm = "is-visible",
    Dm = "has-success",
    Fm = "selected",
    $m = "has-block-selected",
    _m = "mobile",
    Nm = "desktop",
    Rm = "bottom",
    Wm = "data-enable";
  let zm = {},
    Um = class {
      always() {
        this.popupActions.popupOpen();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.popupActions.popupOpen();
        }, 1e3 * t);
      }
      idle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupActions.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupActions.popupOpen(),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, s) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute(xm)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.popupActions = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    Vm = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(Pm)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(Pm))
        )
          return !1;
        this.init();
      }
    };
  const jm = {
    onLoad() {
      zm[this.id] = [];
      this.container.querySelectorAll(ym).forEach((t) => {
        zm[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e = this.popup.classList.contains(_m),
                s = this.popup.classList.contains(Nm),
                i = !f();
              let o = !0;
              if ((((e && !i) || (s && i)) && (o = !1), !o))
                return (
                  this.a11y.removeTrapFocus(),
                  void document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", {
                      bubbles: !0,
                    })
                  )
                );
              (t && !window.Shopify.designMode) ||
                (window.Shopify.designMode ||
                  window.location.pathname.endsWith("/challenge") ||
                  new Um(this.popup, this.modal, this.popupActions),
                this.form &&
                  this.form.classList.contains(Dm) &&
                  this.checkForSuccess(),
                this.modal.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Fm),
                this.popup.parentNode.classList.add($m));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Fm),
                this.popup.parentNode.classList.remove($m));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = this.popup.querySelector(bm)),
                (this.form = this.popup.querySelector(qm)),
                (this.cookie = new Hn(
                  this.popup.getAttribute(Mm),
                  "user_has_closed"
                )),
                (this.isTargeted = new Vm(this.popup)),
                (this.popupActions = new Mu(this.modal, this.modal, !0, !0)),
                (this.a11y = R),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(wm).forEach((t) => {
        zm[this.id].push(
          new (class {
            init() {
              this.showPopup && this.popupActions.popupOpen(),
                this.clickEvents();
            }
            clickEvents() {
              this.acceptButton.addEventListener("click", (t) => {
                t.preventDefault(),
                  window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                    this.popupActions.popupClose()
                  ),
                  document.documentElement.style.setProperty(
                    "--cookie-bar-height",
                    "0px"
                  );
              }),
                document.addEventListener("trackingConsentAccepted", () => {});
            }
            onSelect() {
              this.showPopup &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Fm),
                this.popup.parentNode.classList.add($m));
            }
            onDeselect() {
              this.showPopup &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Fm),
                this.popup.parentNode.classList.remove($m));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = document.querySelector(wm)),
                (this.acceptButton = this.modal.querySelector(Em)),
                (this.enable = "true" === this.modal.getAttribute(Wm)),
                (this.showPopup = !1),
                (this.popupActions = new Mu(this.popup, this.popup, !1, !1)),
                window.Shopify.loadFeatures(
                  [
                    {
                      name: "consent-tracking-api",
                      version: "0.1",
                    },
                  ],
                  (t) => {
                    if (t) throw t;
                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                      s = window.Shopify.customerPrivacy.getTrackingConsent();
                    (this.showPopup =
                      !e && "no_interaction" === s && this.enable),
                      window.Shopify.designMode && (this.showPopup = !0),
                      this.init();
                  }
                );
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Lm).forEach((t) => {
        zm[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e =
                  -1 !==
                  window.location.search.indexOf("?customer_posted=true"),
                s = [...this.holder.classList].toString().includes(Rm);
              e && (this.delay = 0),
                (t && !window.Shopify.designMode) ||
                  (this.show(),
                  this.form.classList.contains(Dm) && this.checkForSuccess()),
                s && this.observeCartBar();
            }
            show() {
              window.location.pathname.endsWith("/challenge") ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Um(this.popup, this.holder, this.popupActions)),
                this.showForm(),
                this.inputField(),
                this.holder.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                );
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            observeCartBar() {
              if (((this.cartBar = document.getElementById(Sm)), !this.cartBar))
                return;
              let t = this.cartBar.classList.contains(Bm);
              document.body.classList.toggle(Om, t),
                (this.observer = new MutationObserver((e) => {
                  for (const s of e)
                    "attributes" === s.type &&
                      ((t = s.target.classList.contains(Bm)),
                      document.body.classList.toggle(Om, t));
                })),
                this.observer.observe(this.cartBar, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                });
            }
            showForm() {
              this.heading.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.heading.classList.add(Im),
                  this.form.classList.remove(Im),
                  this.newsletterField.focus();
              }),
                this.heading.addEventListener("keyup", (t) => {
                  "Enter" === t.code &&
                    this.heading.dispatchEvent(new Event("click"));
                });
            }
            inputField() {
              const t = () => {
                this.resetClassTimer && clearTimeout(this.resetClassTimer),
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(Hm);
              };
              this.newsletterField.addEventListener("input", t),
                this.newsletterField.addEventListener("focus", t),
                this.newsletterField.addEventListener("focusout", () => {
                  this.resetClassTimer && clearTimeout(this.resetClassTimer),
                    (this.resetClassTimer = setTimeout(() => {
                      this.holder.classList.remove(Hm);
                    }, 2e3));
                });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Fm),
                this.popup.parentNode.classList.add($m));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Fm),
                this.popup.parentNode.classList.remove($m));
            }
            onUnload() {
              this.observer && this.observer.disconnect();
            }
            constructor(t) {
              (this.popup = t),
                (this.holder = this.popup.querySelector(km)),
                (this.heading = this.popup.querySelector(Am)),
                (this.newsletterField = this.popup.querySelector(Cm)),
                (this.cookie = new Hn(
                  this.popup.getAttribute(Mm),
                  "newsletter_is_closed"
                )),
                (this.form = this.popup.querySelector(qm)),
                (this.isTargeted = new Vm(this.popup)),
                (this.popupActions = new Mu(this.holder, this.holder, !1, !1)),
                (this.resetClassTimer = 0),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Tm).forEach((t) => {
        zm[this.id].push(
          new (class {
            init() {
              (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Um(this.popup, this.popup, this.popupActions),
                this.popup.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            onSelect() {
              this.popupActions.popupOpen(),
                this.popup.classList.add(Fm),
                this.popup.parentNode.classList.add($m);
            }
            onDeselect() {
              this.popupActions.popupClose(),
                this.popup.classList.remove(Fm),
                this.popup.parentNode.classList.remove($m);
            }
            constructor(t) {
              (this.popup = t),
                (this.cookie = new Hn(
                  this.popup.getAttribute(Mm),
                  "user_has_closed"
                )),
                (this.isTargeted = new Vm(this.popup)),
                (this.popupActions = new Mu(this.popup, this.popup, !1, !1)),
                this.init();
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      zm[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      zm[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
    onSelect() {
      zm[this.id].forEach((t) => {
        "function" == typeof t.onSelect && t.onSelect();
      });
    },
    onDeselect() {
      zm[this.id].forEach((t) => {
        "function" == typeof t.onDeselect && t.onDeselect();
      });
    },
    onUnload() {
      zm[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  Uo("popups", [jm, Wn]);
  const Xm = "[data-password-modal]",
    Jm = "#login_form .errors";
  Uo("password-template", {
    onLoad() {
      new (class {
        constructor(t) {
          (this.container = t.container),
            (this.popupActions = new Mu(
              this.container.querySelector(Xm),
              this.container,
              !0,
              !0
            )),
            this.container.querySelector(Jm) && this.popupActions.popupOpen();
        }
      })(this);
    },
  }),
    Uo("list-collections", [Pn, vl]),
    Uo("columns", [vl, Pn]),
    Uo("newsletter", Wn),
    customElements.get("compare-images") ||
      customElements.define("compare-images", mm);
  const Ym = "[data-scroll-to]",
    Qm = "[data-tooltip]",
    Gm = "[data-collapsible-trigger]",
    Km = "open",
    Zm = "data-scroll-to",
    tv = "data-tooltip-stop-mouseenter",
    ev = {};
  const sv = {
      onLoad() {
        ev[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                const e = this.container.querySelector(t.getAttribute(Zm));
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            In(t.getBoundingClientRect().top + 1);
            const e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              const t = null == e ? void 0 : e.querySelector(Gm);
              e.hasAttribute(Km) ||
                null == t ||
                t.dispatchEvent(new Event("click"));
            }
            const s = document.querySelectorAll(`${Qm}:not([${tv}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(tv, ""),
                  setTimeout(() => {
                    t.removeAttribute(tv);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons = this.container.querySelectorAll(Ym)),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    iv = "[data-scroll-spy]",
    ov = "is-selected",
    nv = "data-scroll-spy",
    rv = "data-scroll-spy-mobile",
    av = "data-scroll-spy-desktop",
    lv = "data-scroll-trigger-point",
    cv = {};
  const hv = {
    onLoad() {
      var t;
      (cv[this.id] = []),
        null === (t = this.container.querySelectorAll(iv)) ||
          void 0 === t ||
          t.forEach((t) => {
            const e = this.container.querySelector(t.getAttribute(nv));
            cv[this.id].push(
              new (class {
                init() {
                  this.toggleScrollObserver(),
                    document.addEventListener(
                      "theme:resize:width",
                      this.toggleScrollObserver
                    );
                }
                toggleScrollObserver() {
                  this.isEligible()
                    ? this.initialized ||
                      (document.addEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !0))
                    : (document.removeEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !1));
                }
                isEligible() {
                  const t = f();
                  return (
                    (!t && this.anchor.hasAttribute(rv)) ||
                    (t && this.anchor.hasAttribute(av)) ||
                    (!this.anchor.hasAttribute(av) &&
                      !this.anchor.hasAttribute(rv))
                  );
                }
                onScroll() {
                  this.top = this.elementToSpy.getBoundingClientRect().top;
                  const t = Math.round(window.innerHeight),
                    e = Math.round(window.scrollY),
                    s = e + t,
                    i = Math.round(this.top + e),
                    o = this.elementToSpy.offsetHeight;
                  i < s &&
                    !(i + o < e) &&
                    this.triggerPointReached() &&
                    (this.anchorSiblings.forEach((t) => {
                      t.matches(this.anchorSelector) || t.classList.remove(ov);
                    }),
                    this.anchor.classList.add(ov));
                }
                triggerPointReached() {
                  let t = !1;
                  switch (this.triggerPoint) {
                    case "top":
                    default:
                      t = this.top <= 0;
                      break;
                    case "middle":
                      t = this.top <= window.innerHeight / 2;
                      break;
                    case "bottom":
                      t = this.top <= window.innerHeight;
                  }
                  return t;
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:resize:width",
                    this.toggleScrollObserver
                  ),
                    document.removeEventListener(
                      "theme:scroll",
                      this.scrollCallback
                    );
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.elementToSpy = e),
                    (this.anchorSelector = `[${nv}="#${this.elementToSpy.id}"]`),
                    (this.anchor = this.container.querySelector(
                      this.anchorSelector
                    )),
                    (this.anchorSiblings = this.container.querySelectorAll(
                      `[${nv}]`
                    )),
                    (this.initialized = !1),
                    this.anchor &&
                      ((this.triggerPoint = this.anchor.getAttribute(lv)),
                      (this.scrollCallback = () => this.onScroll()),
                      (this.toggleScrollObserver =
                        this.toggleScrollObserver.bind(this)),
                      this.init());
                }
              })(this.container, e)
            );
          });
    },
    onUnload() {
      cv[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  Uo("sidebar", [sv, hv]);
  const dv = "[data-hover-target]",
    uv = "[data-collection-image]",
    pv = "data-hover-target",
    mv = "is-visible",
    vv = "is-selected";
  let gv = {};
  Uo("collections-hover", [
    {
      onLoad() {
        gv[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  const e = t.currentTarget.getAttribute(pv);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            const e = this.container.querySelector(`[${pv}="${t}"]`),
              s = this.container.querySelector(`#${t}:not(.${mv})`),
              i = this.container.querySelector(`${dv}.${vv}`),
              o = this.container.querySelector(`${uv}.${mv}`);
            s &&
              f() &&
              (null == o || o.classList.remove(mv),
              null == i || i.classList.remove(vv),
              s.classList.add(mv),
              e.classList.add(vv));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(dv)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        gv[this.id].onBlockSelect(t);
      },
    },
    hv,
  ]);
  const fv = "[data-featured-image]",
    yv = "[data-featured-aside]",
    bv = "[data-featured-content]",
    wv = "[data-featured-wrapper]",
    Ev = "data-horizontal-scroll",
    Sv = "data-horizontal-scroll-reversed",
    Lv = {};
  Uo("featured-product", [
    {
      onLoad() {
        Lv[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              ((this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              )),
              document.addEventListener("theme:scroll", this.scrollEvent)),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          scrollEvents() {
            this.requestAnimationSticky ||
              (this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              ));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null));
          }
          calculateHorizontalPosition() {
            let t = window.scrollY + this.headerHeight;
            const e = t + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              i = this.imagesHolder.offsetHeight,
              o = s + i + this.headerHeight,
              n = i - (window.innerHeight - this.headerHeight),
              r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
              (a *= this.images.length - 1),
              this.container.style.setProperty("--translateX", a * r + "%"),
              this.lastPercent !== a
                ? (this.requestAnimationSticky = requestAnimationFrame(
                    this.calculateHorizontalPositionEvent
                  ))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.lastPercent = a);
          }
          calculateHeight() {
            let { stickyHeaderHeight: t } = l();
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = t);
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(Ev)),
              (this.horizontalScrollReversed = this.container.hasAttribute(Sv)),
              (this.images = this.container.querySelectorAll(fv)),
              (this.imagesHolder = this.container.querySelector(yv)),
              (this.contentHolder = this.container.querySelector(bv)),
              (this.wrapper = this.container.querySelector(wv)),
              (this.requestAnimationSticky = null),
              (this.lastPercent = 0),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.calculateHorizontalPositionEvent = () =>
                this.calculateHorizontalPosition()),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        Lv[this.id].onUnload(t);
      },
    },
  ]);
  const kv = "[data-timeline-holder]",
    Av = "[data-timeline-rows]",
    Cv = "[data-timeline-row]",
    Tv = "[data-timeline-row-editor]",
    qv = "[data-timeline-button]",
    xv = "[data-block-scroll]",
    Mv = "is-selected",
    Pv = {};
  Uo("timeline", [
    {
      onLoad() {
        Pv[this.id] = new (class {
          init() {
            this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              )),
              this.isDesktopView &&
                !this.isScrollEnabled &&
                ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.addEventListener("scroll", this.scrollEvent),
              document.addEventListener("theme:resize:width", this.resizeEvent),
              this.buttons.length &&
                this.buttons.forEach((t, e) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = t.currentTarget.closest(Cv);
                    if (s)
                      if (f()) {
                        const t = Math.max(...this.rowsHeight),
                          s = this.holderHeight / this.rows.length,
                          i = this.holder.getBoundingClientRect().top;
                        In((e > 0 && t < s ? s * e + i : i) + 1);
                      } else {
                        const t = 16,
                          e = s.offsetLeft - t;
                        this.rowsHolder.scrollTo({
                          left: e,
                          behavior: "smooth",
                        });
                      }
                  });
                });
          }
          resizeEvents() {
            (this.holderTop =
              this.holder.getBoundingClientRect().top + window.scrollY),
              (this.holderHeight = this.holder.offsetHeight),
              this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              ));
            const t = f();
            t && !this.isScrollEnabled
              ? ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent))
              : !t &&
                this.isScrollEnabled &&
                ((this.isScrollEnabled = !1),
                document.removeEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            if (!this.requestAnimation) {
              const e = t.currentTarget;
              this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition(e)
              );
            }
          }
          removeAnimationFrame() {
            this.requestAnimation &&
              (cancelAnimationFrame(this.requestAnimation),
              (this.requestAnimation = null));
          }
          calculateRowsDimensions() {
            if (this.rows.length) {
              (this.rowsHeight = []), (this.rowsWidth = 0);
              let t = 0;
              this.rows.forEach((e, s) => {
                if (
                  (this.rowsHeight.push(e.offsetHeight),
                  (this.rowsWidth +=
                    e.offsetWidth + parseInt(getComputedStyle(e).marginRight)),
                  window.Shopify.designMode)
                ) {
                  const n = this.container.querySelectorAll(Tv);
                  var i, o;
                  n.length &&
                    ((t += e.offsetHeight),
                    null === (i = n[s]) ||
                      void 0 === i ||
                      i.style.setProperty(
                        "--row-height-min",
                        `${e.offsetHeight}px`
                      ),
                    null === (o = n[s + 1]) ||
                      void 0 === o ||
                      o.style.setProperty("--row-top-mobile", `${t}px`));
                }
              });
            }
          }
          calculatePosition(t = null) {
            this.removeAnimationFrame();
            const e = f(),
              s = this.holderHeight / this.rows.length;
            let i = this.holderTop;
            const o = window.innerHeight,
              n = window.scrollY + 1.5 * o;
            let r = 0;
            if (!e && t) {
              const e = t.scrollLeft - 16,
                s = t.offsetWidth;
              (r = (e / (this.rowsWidth - s)) * 100),
                this.holder.style.setProperty("--percent-mobile", `${r}%`);
            }
            (e &&
              (n < this.holderTop ||
                n > this.holderTop + this.holderHeight + o)) ||
              this.rows.forEach((t, o) => {
                if (o > 0) {
                  const o = (t.offsetLeft / this.rowsWidth) * 100;
                  let l = r > o;
                  var a;
                  e &&
                    ((l = i + s < n),
                    i - s < n &&
                      (null === (a = t.previousElementSibling) ||
                        void 0 === a ||
                        a.style.setProperty(
                          "--percent-desktop",
                          ((n - i) / s) * 100 + "%"
                        ))),
                    t.classList.toggle(Mv, l);
                }
                i += s;
              });
          }
          onUnload() {
            this.isScrollEnabled &&
              ((this.isScrollEnabled = !1),
              document.removeEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.removeEventListener("scroll", this.scrollEvent),
              document.removeEventListener(
                "theme:resize:width",
                this.resizeEvent
              );
          }
          onBlockSelect(t) {
            const e = this.container.querySelector(xv);
            if (e) {
              const s = t.srcElement,
                i = [...s.parentElement.children].indexOf(s),
                o = this.rows[i];
              o &&
                e.scrollTo({
                  top: 0,
                  left: o.offsetLeft,
                  behavior: "smooth",
                });
            }
          }
          constructor(t) {
            (this.container = t.container),
              (this.rows = this.container.querySelectorAll(Cv)),
              (this.holder = this.container.querySelector(kv)),
              this.rows.length < 2 ||
                !this.holder ||
                ((this.rowsWidth = 0),
                (this.rowsHeight = []),
                (this.holderTop =
                  this.holder.getBoundingClientRect().top + window.scrollY),
                (this.holderHeight = this.holder.offsetHeight),
                (this.buttons = this.container.querySelectorAll(qv)),
                (this.rowsHolder = this.container.querySelector(Av)),
                (this.requestAnimation = null),
                (this.isDesktopView = f()),
                (this.isScrollEnabled = !1),
                (this.scrollEvent = (t) => this.scrollEvents(t)),
                (this.resizeEvent = () => this.resizeEvents()),
                this.init());
          }
        })(this);
      },
      onUnload(t) {
        Pv[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Pv[this.id].onBlockSelect(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      Vo("*");
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          Ru({
            url: window.theme.assets.smoothscroll,
          });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.themeAddresses,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);
